var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg3({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 400,
    height: 532,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 400 532",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".uuid-ff523dc7-75db-4957-a022-a7a5c3a78956{fill:url(#uuid-c0c074e0-dd33-4ff4-8444-2bec95a4641a);}.uuid-755e9d62-6e6a-4665-8dbe-5ccb9f56133f{fill:#111113;}.uuid-97728ca5-f369-4d43-abb3-ae09594750e3{opacity:.4;}.uuid-97728ca5-f369-4d43-abb3-ae09594750e3,.uuid-61e72ca5-1928-4024-912a-46feb0769b5d{fill:#b4ddc0;}.uuid-97728ca5-f369-4d43-abb3-ae09594750e3,.uuid-86c3b3c3-2ad6-4416-99fd-ad0b913fd4a3,.uuid-c8572e57-ce03-4734-a329-bb8682074307{isolation:isolate;}.uuid-6de3603d-e94a-470c-ad10-dd53bef6d82d{fill:url(#uuid-1cbee2e2-551d-4c48-b92f-3744247021fc);}.uuid-7ee8549f-7565-47fd-9e28-eccbdd30cb03{fill:#2f2f31;mix-blend-mode:screen;opacity:.5;}.uuid-7cde0a89-1d0a-4d4f-97d5-88227c5debc1{fill:#bdb6ba;}.uuid-caab3569-67dd-48f8-93fa-229de7efa791{fill:#bcc7cb;}.uuid-2c3d25ec-04fa-4bff-9df4-c62b3b45698f{fill:url(#uuid-02aa426c-6e42-4f8b-b2c1-b939415b8738);}.uuid-c9bc928b-69dc-453d-bb84-6b430ab8dcc5{fill:url(#uuid-65416c32-d78b-4cac-86a7-5805785c5e2b);}.uuid-c3d1e125-47da-4ffc-ae60-24f5a9ade738{fill:#7c7e80;}.uuid-0c9c3356-e5d9-4504-ade4-a7ed86cb66ac{fill:#bababa;}.uuid-0a1bbc5a-b788-4ce2-8500-fb677d294b64{fill:#fff;}.uuid-5b12d0c7-67da-4724-9c8f-41693657877a{fill:#2f3a3e;}.uuid-4bc95293-8cd5-4577-8443-df765a30e13d{fill:url(#uuid-cc95ceb6-8b34-48a5-9b54-998ccfadc9e8);}.uuid-fd5f24bc-eaeb-449a-beb4-7a18ffbf407d{fill:url(#uuid-6c42301d-298f-487c-92b7-51c5552b03b3);}.uuid-843519b8-8e9f-4a81-9212-d141e78086bf{fill:#3e4442;}.uuid-28380f90-cb0a-4c2c-a4d5-efa0ff11e1e8{fill:url(#uuid-1b637e3e-6548-4ede-8b63-5723c07dbf71);}.uuid-a21a5fc7-dfaf-4984-83a4-779d70d4a70c{fill:#e2bf9a;}.uuid-7c0d99eb-719b-4d41-a9c4-28b0e89f84ad{fill:#566479;}.uuid-0399e8d7-ee57-43b0-aad9-444b40b9d011{fill:#bbbdbf;}.uuid-488da7f8-93e7-4c83-947b-6ac19dfe1036{fill:url(#uuid-aed64cc9-242c-42eb-a6d0-6597cc25afb7);}.uuid-855bc41b-68c4-4f30-9e65-8a3ab6ef699e{fill:#eaf7f9;}.uuid-931483f3-9c4d-4d81-99bc-c1c8ecdf2fb9{fill:#666;}.uuid-183f9d87-d256-4c1a-bf2f-92b90daf91d2{fill:#637c86;mix-blend-mode:multiply;opacity:.6;}.uuid-e12a521e-a6bf-4f2d-b75a-db1725d6a1e7{fill:url(#uuid-00cfb079-43fa-4d23-b39d-698fd296ef51);}.uuid-c8572e57-ce03-4734-a329-bb8682074307{fill:url(#uuid-7a77c7b0-eafc-48db-88fa-03844f0f49b1);opacity:.3;}.uuid-2bd656d8-662a-4244-91e9-27755fde6f06{fill:#111115;}.uuid-73531d05-360a-4fd3-891d-b15041dd593e{fill:#b8babc;}.uuid-1dcdb0a8-3b20-4c1c-95c7-f47a7168dde0{fill:#c70039;}.uuid-623bd507-96b6-4874-bc7a-c17c7f071085{fill:#aaacaf;}.uuid-650b9594-cc22-499e-a5fd-acbf290376d0{fill:#8d9092;}.uuid-dee9cec7-f176-469b-80bb-bc3fd90fd066{fill:none;stroke:url(#uuid-8fc38394-c95e-4116-99a2-f33cf5dec4ff);stroke-miterlimit:10;stroke-width:.8px;}.uuid-75c5a858-763e-4c1a-8654-9cf21e8b25e3{fill:#cbccce;}.uuid-b30c3822-e79e-4032-b619-ccc41c017703{fill:#dcddde;}.uuid-3f7b1093-941b-4132-90b2-fa05339cb1e1{fill:#b4cdd8;}.uuid-6f6e0027-f60c-41b0-884c-328751b12d41{fill:#7f949c;}.uuid-eabdd1ac-7543-476f-a9a1-efc11eeff44a{fill:url(#uuid-a1f9dfb0-f922-43dc-9412-236988603e15);}.uuid-e5c2021b-defc-4aaf-90a6-399609577ef4{fill:#779483;}.uuid-425e26d6-b358-4618-a922-ed49ef724d85{fill:#9ea1a3;}.uuid-dac06365-2717-4c05-b8be-afcf2a63f34d{fill:#343434;}.uuid-21e078d3-d5d9-462e-9988-8c5b2ff32579{fill:#d9d9d9;}.uuid-9a16e04f-a073-4700-a3ef-44e84614b0dd{fill:url(#uuid-91d290b4-fa58-4bd4-a65c-191dea67e801);}.uuid-48229acf-073d-4e34-be85-8af05d5d9ae6{fill:#333739;}.uuid-28dfd135-468a-4929-9568-7d7fb77366dd{fill:#d1d3d4;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-8fc38394-c95e-4116-99a2-f33cf5dec4ff",
    x1: 53.1,
    y1: 56.3,
    x2: 400,
    y2: 56.3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231f20"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-1b637e3e-6548-4ede-8b63-5723c07dbf71",
    x1: 171.4,
    y1: 190.1,
    x2: 226.8,
    y2: 190.1,
    gradientTransform: "translate(0 534) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#090909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2b2d2f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#46494d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#595d62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#65696f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#696d73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#676b71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#424448"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#26282b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#161718"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#101112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#141516"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#1e2022"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#313336"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4a4d51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#585c61"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-00cfb079-43fa-4d23-b39d-698fd296ef51",
    x1: 171.4,
    y1: 192.7,
    x2: 226.8,
    y2: 192.7,
    gradientTransform: "translate(0 534) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#090909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#232527"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#37393c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#424549"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#46494d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#414448"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#26282a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#161718"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101112"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-cc95ceb6-8b34-48a5-9b54-998ccfadc9e8",
    x1: 174.6,
    y1: 196.5,
    x2: 223.5,
    y2: 196.5,
    gradientTransform: "translate(0 534) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2b2d2f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#46494d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#595d62"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#65696f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#696d73"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#676b71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#424448"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#26282b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#161718"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#101112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#141516"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#1e2022"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#313336"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4a4d51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#585c61"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-6c42301d-298f-487c-92b7-51c5552b03b3",
    x1: 174.6,
    y1: 201.1,
    x2: 223.5,
    y2: 201.1,
    xlinkHref: "#uuid-00cfb079-43fa-4d23-b39d-698fd296ef51"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-a1f9dfb0-f922-43dc-9412-236988603e15",
    x1: 193.1,
    y1: 190.3,
    x2: 205,
    y2: 202.1,
    gradientTransform: "translate(0 534) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d17b4c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#ffdb9d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#fdd799"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#f5cd8e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#e8ba7c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#d6a162"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#c08041"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#ba7839"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#c27f42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d69159"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d9935c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-c0c074e0-dd33-4ff4-8444-2bec95a4641a",
    x1: 190.3,
    y1: 197.6,
    x2: 190.7,
    y2: 197.9,
    xlinkHref: "#uuid-1b637e3e-6548-4ede-8b63-5723c07dbf71"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-1cbee2e2-551d-4c48-b92f-3744247021fc",
    x1: 190.3,
    y1: 194.4,
    x2: 190.7,
    y2: 194.7,
    xlinkHref: "#uuid-1b637e3e-6548-4ede-8b63-5723c07dbf71"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-65416c32-d78b-4cac-86a7-5805785c5e2b",
    x1: 207.5,
    y1: 197.6,
    x2: 207.8,
    y2: 197.9,
    xlinkHref: "#uuid-1b637e3e-6548-4ede-8b63-5723c07dbf71"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-91d290b4-fa58-4bd4-a65c-191dea67e801",
    x1: 207.5,
    y1: 194.4,
    x2: 207.8,
    y2: 194.7,
    xlinkHref: "#uuid-1b637e3e-6548-4ede-8b63-5723c07dbf71"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-02aa426c-6e42-4f8b-b2c1-b939415b8738",
    x1: 181.5,
    y1: 199.4,
    x2: 216.6,
    y2: 260.2,
    gradientTransform: "translate(0 534) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9fabad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#d5e5e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#c3cdcf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ddecf0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-7a77c7b0-eafc-48db-88fa-03844f0f49b1",
    x1: 177.7,
    y1: 208.4,
    x2: 220.4,
    y2: 251.2,
    gradientTransform: "translate(0 534) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8d9799"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#959fa2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#aab6b9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#c5d3d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#e6f6fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#dcebef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#bac7ca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#a2adaf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#939d9f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#8e9799"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#939c9e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#a1abae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#b8c4c7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#d8e7eb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#e6f6fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8d9799"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-aed64cc9-242c-42eb-a6d0-6597cc25afb7",
    x1: 340.4,
    y1: -460.2,
    x2: 341,
    y2: -460.2,
    gradientTransform: "translate(-203.8 752.7) scale(.9)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#001018"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#001b25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#00202b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#00222d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#001d27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#000e15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "uuid-86c3b3c3-2ad6-4416-99fd-ad0b913fd4a3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "uuid-d560726d-0202-4b47-bb63-3730f57642c5"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 532
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-0a1bbc5a-b788-4ce2-8500-fb677d294b64",
    d: "M54.3,34h5.3c2.9,0,5.1,1.5,5.1,4.3s-2.2,4.6-5.3,4.6h-2.9v6.5h-2.2v-15.4ZM56.5,41.1h2.8c1.9,0,3.2-.7,3.2-2.8s-1.3-2.6-3.2-2.6h-2.8v5.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-0a1bbc5a-b788-4ce2-8500-fb677d294b64",
    d: "M66.8,41.9c0-1.8,0-3.3,0-3.9h2c0,.5,0,1.3,0,2.3.5-1.3,1.7-2.4,3.6-2.5v2.2c-2.5,0-3.6,1.4-3.6,3.9v5.5h-2.1v-7.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-0a1bbc5a-b788-4ce2-8500-fb677d294b64",
    d: "M83.7,43.5c0,3.3-1.5,6.1-5.2,6.1s-5-2.9-5-6,1.6-5.8,5.2-5.8,5,2.5,5,5.7ZM75.6,43.5c0,2.6,1,4.3,3,4.3s2.9-1.7,2.9-4.4-1-4-3-4-2.9,1.7-2.9,4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-0a1bbc5a-b788-4ce2-8500-fb677d294b64",
    d: "M95.2,33.1v13.3c0,1.1,0,2.3,0,3h-2c0-.3,0-1,0-1.6-.6,1.3-1.5,1.8-3.4,1.8-2.9,0-4.4-2.5-4.4-5.9s1.7-5.9,4.8-5.9,2.7.7,2.9,1.3v-6h2.1ZM87.5,43.6c0,2.6,1.1,4.2,2.9,4.2s2.8-1.8,2.8-4.3-.8-4-2.7-4-3,1.5-3,4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-0a1bbc5a-b788-4ce2-8500-fb677d294b64",
    d: "M107.1,46.2c0,1.5,0,2.7,0,3.3h-2c0-.3,0-1-.1-1.7-.6,1.2-1.7,1.9-3.3,1.9s-3.5-1-3.5-3.9v-7.7h2.1v7.3c0,1.4.5,2.5,2.1,2.5s2.6-1,2.6-3.4v-6.4h2.1v8.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-0a1bbc5a-b788-4ce2-8500-fb677d294b64",
    d: "M119.1,45.7c-.4,2.2-1.9,3.9-4.7,3.9s-4.9-2.1-4.9-5.9,1.7-5.9,5-5.9,4.4,2.2,4.5,4h-2.1c-.2-1.2-.9-2.4-2.5-2.4s-2.8,1.7-2.8,4.2,1,4.3,2.8,4.3,2.2-1,2.5-2.3h2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-0a1bbc5a-b788-4ce2-8500-fb677d294b64",
    d: "M120.3,38h1.8v-3.3h2.1v3.3h2.2v1.7h-2.2v6.9c0,.9.2,1.3,1.2,1.3s.6,0,.8,0v1.5c-.5.2-1.2.2-1.6.2-1.8,0-2.6-.7-2.6-2.6v-7.2h-1.8v-1.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-0a1bbc5a-b788-4ce2-8500-fb677d294b64",
    d: "M129.5,46.1c.2,1.2,1.1,1.9,2.4,1.9s2.1-.8,2.1-1.7-.7-1.5-2.6-2c-2.8-.8-3.6-1.8-3.6-3.3s1-3.2,3.9-3.2,3.9,1.5,4.1,3.3h-2c-.2-.9-.6-1.7-2.1-1.7s-1.8.6-1.8,1.5.4,1.2,2.3,1.7c2.9.8,3.9,1.8,3.9,3.6s-1.7,3.5-4.2,3.5-4.2-1.1-4.4-3.5h2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-0a1bbc5a-b788-4ce2-8500-fb677d294b64",
    d: "M63.2,88.8c-.4,2-1.7,3.8-4.6,3.8s-5.1-2.8-5.1-6.8,1.6-6.5,5.2-6.5,4.2,1.7,4.5,3.9h-1.3c-.4-1.7-1.3-2.8-3.3-2.8s-3.9,2.6-3.9,5.5.9,5.7,3.9,5.7,2.9-1.1,3.4-2.8h1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-0a1bbc5a-b788-4ce2-8500-fb677d294b64",
    d: "M72.9,87.6c0,2.7-1.1,5-4.1,5s-3.9-2.4-3.9-5,1.4-4.8,4.1-4.8,4,2,4,4.7ZM66.1,87.7c0,2.2,1,3.9,2.8,3.9s2.7-1.7,2.7-4-.9-3.7-2.8-3.7-2.8,1.6-2.8,3.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-0a1bbc5a-b788-4ce2-8500-fb677d294b64",
    d: "M75.1,86.3c0-1.5,0-2.8,0-3.2h1.2c0,.5,0,1.1,0,2,.5-1.3,1.6-2.2,3.1-2.2v1.3c-2.2.1-3.1,1.6-3.1,3.6v4.8h-1.2v-6.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-0a1bbc5a-b788-4ce2-8500-fb677d294b64",
    d: "M82,91.2v5h-1.2v-10.4c0-1.3,0-2.2,0-2.8h1.2c0,.3,0,1.1,0,1.6.5-1.1,1.5-1.8,3-1.8s3.5,1.7,3.5,4.7-1.7,5-3.8,5-2.2-.6-2.7-1.4ZM87.3,87.7c0-2.3-1-3.7-2.6-3.7s-2.7,1.5-2.7,3.9.4,3.8,2.6,3.8,2.7-1.4,2.7-3.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-0a1bbc5a-b788-4ce2-8500-fb677d294b64",
    d: "M98.1,87.6c0,2.7-1.1,5-4.1,5s-3.9-2.4-3.9-5,1.4-4.8,4.1-4.8,4,2,4,4.7ZM91.3,87.7c0,2.2,1,3.9,2.8,3.9s2.7-1.7,2.7-4-.9-3.7-2.8-3.7-2.8,1.6-2.8,3.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-0a1bbc5a-b788-4ce2-8500-fb677d294b64",
    d: "M100.2,86.3c0-1.5,0-2.8,0-3.2h1.2c0,.5,0,1.1,0,2,.5-1.3,1.6-2.2,3.1-2.2v1.3c-2.2.1-3.1,1.6-3.1,3.6v4.8h-1.2v-6.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-0a1bbc5a-b788-4ce2-8500-fb677d294b64",
    d: "M112.2,90.5c0,.7,0,1.5.1,2h-1.1c0-.3-.1-.8-.1-1.6-.3,1-1.3,1.7-2.9,1.7-2.3,0-2.9-1.6-2.9-2.8s.8-2.9,4.2-2.9h1.6v-1c0-.9-.3-2-2-2s-2,.7-2.2,1.8h-1.2c.2-1.6,1.1-2.8,3.4-2.8s3.2.8,3.2,2.9v4.8ZM111.1,87.8h-1.6c-2.5,0-3,1-3,2s.6,1.9,1.9,1.9c2,0,2.7-1.3,2.7-3.6v-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-0a1bbc5a-b788-4ce2-8500-fb677d294b64",
    d: "M113.5,83.1h1.6v-2.8h1.2v2.8h2v1h-2v6.3c0,.8.2,1.2,1,1.2s.6,0,.8,0v.9c-.3.1-.8.2-1.1.2-1.2,0-1.9-.4-1.9-1.9v-6.6h-1.6v-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-0a1bbc5a-b788-4ce2-8500-fb677d294b64",
    d: "M120.5,88c0,2.2.9,3.7,2.7,3.7s2.2-1.2,2.4-1.7h1.2c-.3,1-1.1,2.8-3.6,2.8s-3.8-2.4-3.8-4.9,1.1-4.8,3.9-4.8,3.7,2.3,3.7,4.4,0,.7,0,.7h-6.4ZM125.7,87c0-1.8-.8-3.1-2.5-3.1s-2.5,1.9-2.6,3.1h5.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-0a1bbc5a-b788-4ce2-8500-fb677d294b64",
    d: "M143.1,92.5h-1c0-.4-.1-.9-.1-2-.7,1.5-1.9,2.2-3.9,2.2-3.4,0-5-2.9-5-6.6s1.9-6.7,5.4-6.7,4.1,1.4,4.5,3.7h-1.2c-.4-1.6-1.4-2.6-3.4-2.6-2.8,0-4.1,2.4-4.1,5.6s1.2,5.5,3.8,5.5,3.6-2.1,3.6-4.8h0c0,0-3.6,0-3.6,0v-1.1h4.8v6.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-0a1bbc5a-b788-4ce2-8500-fb677d294b64",
    d: "M146.3,78.9h1.2v1.9h-1.2v-1.9ZM146.3,83.1h1.2v9.4h-1.2v-9.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-0a1bbc5a-b788-4ce2-8500-fb677d294b64",
    d: "M150.6,92.5v-8.4h-1.5v-1h1.5v-1.3c0-1.6.5-3.1,2.4-3.1s.6,0,.8.1v1.1c-.2,0-.5,0-.8,0-.9,0-1.3.6-1.3,1.9v1.4h1.8v1h-1.8v8.4h-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-0a1bbc5a-b788-4ce2-8500-fb677d294b64",
    d: "M153.6,83.1h1.6v-2.8h1.2v2.8h2v1h-2v6.3c0,.8.2,1.2,1,1.2s.6,0,.8,0v.9c-.3.1-.8.2-1.1.2-1.2,0-1.9-.4-1.9-1.9v-6.6h-1.6v-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-0a1bbc5a-b788-4ce2-8500-fb677d294b64",
    d: "M160.4,89.8c.2,1.2,1.1,1.8,2.3,1.8s2-.8,2-1.7-.6-1.5-2.3-1.9c-2.2-.6-2.8-1.4-2.8-2.6s.9-2.5,3-2.5,3,1.2,3.1,2.6h-1.2c-.2-.9-.6-1.7-2-1.7s-1.7.6-1.7,1.5.3,1.2,2,1.7c2.3.6,3.1,1.4,3.1,2.9s-1.3,2.8-3.2,2.8-3.3-.9-3.4-2.8h1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-0a1bbc5a-b788-4ce2-8500-fb677d294b64",
    d: "M64.6,115.4c0-2.5,0-4.9,0-6.2h0c-.6,2.2-2.8,8.2-4.3,12h-1.2c-1.1-3.1-3.4-9.6-4-12h0c0,1.5.1,4.4.1,6.6v5.4h-1.2v-12.9h1.9c1.5,4.1,3.4,9.7,3.9,11.4h0c.2-1.1,2.5-7.3,4.1-11.4h1.8v12.9h-1.2v-5.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-0a1bbc5a-b788-4ce2-8500-fb677d294b64",
    d: "M69.3,116.6c0,2.2.9,3.7,2.7,3.7s2.2-1.2,2.4-1.7h1.2c-.3,1-1.1,2.8-3.6,2.8s-3.8-2.4-3.8-4.9,1.1-4.8,3.9-4.8,3.7,2.3,3.7,4.4,0,.7,0,.7h-6.4ZM74.5,115.7c0-1.8-.8-3.1-2.5-3.1s-2.5,1.9-2.6,3.1h5.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-0a1bbc5a-b788-4ce2-8500-fb677d294b64",
    d: "M77.8,114.6c0-1.6,0-2.5,0-2.9h1.2c0,.2,0,1.1,0,1.4.4-.8,1.2-1.6,2.6-1.6s2.1.5,2.4,1.7c.4-.9,1.3-1.7,2.8-1.7s2.7.7,2.7,3.2v6.4h-1.2v-6.2c0-1.3-.4-2.3-1.9-2.3s-2.3,1.4-2.3,2.9v5.6h-1.2v-6.3c0-1.3-.5-2.2-1.8-2.2s-2.3,1.1-2.3,3.1v5.4h-1.2v-6.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-0a1bbc5a-b788-4ce2-8500-fb677d294b64",
    d: "M93,116.6c0,2.2.9,3.7,2.7,3.7s2.2-1.2,2.4-1.7h1.2c-.3,1-1.1,2.8-3.6,2.8s-3.8-2.4-3.8-4.9,1.1-4.8,3.9-4.8,3.7,2.3,3.7,4.4,0,.7,0,.7h-6.4ZM98.1,115.7c0-1.8-.8-3.1-2.5-3.1s-2.5,1.9-2.6,3.1h5.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-0a1bbc5a-b788-4ce2-8500-fb677d294b64",
    d: "M101.5,114.7c0-2,0-2.5,0-2.9h1.2c0,.2,0,1.2,0,1.6.4-.9,1.2-1.8,2.8-1.8s3,.9,3,3.6v6h-1.2v-5.9c0-1.5-.5-2.6-2-2.6s-2.6,1.5-2.6,3.6v4.9h-1.2v-6.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-0a1bbc5a-b788-4ce2-8500-fb677d294b64",
    d: "M109.9,111.7h1.6v-2.8h1.2v2.8h2v1h-2v6.3c0,.8.2,1.2,1,1.2s.6,0,.8,0v.9c-.3.1-.8.2-1.1.2-1.2,0-1.9-.4-1.9-1.9v-6.6h-1.6v-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-0a1bbc5a-b788-4ce2-8500-fb677d294b64",
    d: "M123.7,116.2c0,2.7-1.1,5-4.1,5s-3.9-2.4-3.9-5,1.4-4.8,4.1-4.8,4,2,4,4.7ZM116.9,116.3c0,2.2,1,3.9,2.8,3.9s2.7-1.7,2.7-4-.9-3.7-2.8-3.7-2.8,1.6-2.8,3.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-0a1bbc5a-b788-4ce2-8500-fb677d294b64",
    d: "M126.2,118.5c.2,1.2,1.1,1.8,2.3,1.8s2-.8,2-1.7-.6-1.5-2.3-1.9c-2.2-.6-2.8-1.4-2.8-2.6s.9-2.5,3-2.5,3,1.2,3.1,2.6h-1.2c-.2-.9-.6-1.7-2-1.7s-1.7.6-1.7,1.5.3,1.2,2,1.7c2.3.6,3.1,1.4,3.1,2.9s-1.3,2.8-3.2,2.8-3.3-.9-3.4-2.8h1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-0a1bbc5a-b788-4ce2-8500-fb677d294b64",
    d: "M54.1,136.8h4.1c3,0,5.6,2,5.6,6.1s-2.2,6.8-5.9,6.8h-3.9v-12.9ZM55.3,148.7h2.6c3.2,0,4.7-2.1,4.7-5.7s-2-5.1-4.7-5.1h-2.6v10.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-0a1bbc5a-b788-4ce2-8500-fb677d294b64",
    d: "M66.3,136.1h1.2v1.9h-1.2v-1.9ZM66.3,140.3h1.2v9.4h-1.2v-9.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-0a1bbc5a-b788-4ce2-8500-fb677d294b64",
    d: "M76.6,147.8c0,.7,0,1.5.1,2h-1.1c0-.3-.1-.8-.1-1.6-.3,1-1.3,1.7-2.9,1.7-2.3,0-2.9-1.6-2.9-2.8s.8-2.9,4.2-2.9h1.6v-1c0-.9-.3-2-2-2s-2,.7-2.2,1.8h-1.2c.2-1.6,1.1-2.8,3.4-2.8s3.2.8,3.2,2.9v4.8ZM75.5,145.1h-1.6c-2.5,0-3,1-3,2s.6,1.9,1.9,1.9c2,0,2.7-1.3,2.7-3.6v-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-0a1bbc5a-b788-4ce2-8500-fb677d294b64",
    d: "M79.5,143.5c0-1.5,0-2.8,0-3.2h1.2c0,.5,0,1.1,0,2,.5-1.3,1.6-2.2,3.1-2.2v1.3c-2.2.1-3.1,1.6-3.1,3.6v4.8h-1.2v-6.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-0a1bbc5a-b788-4ce2-8500-fb677d294b64",
    d: "M85.4,136.1h1.2v1.9h-1.2v-1.9ZM85.4,140.3h1.2v9.4h-1.2v-9.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-0a1bbc5a-b788-4ce2-8500-fb677d294b64",
    d: "M90,145.2c0,2.2.9,3.7,2.7,3.7s2.2-1.2,2.4-1.7h1.2c-.3,1-1.1,2.8-3.6,2.8s-3.8-2.4-3.8-4.9,1.1-4.8,3.9-4.8,3.7,2.3,3.7,4.4,0,.7,0,.7h-6.4ZM95.2,144.3c0-1.8-.8-3.1-2.5-3.1s-2.5,1.9-2.6,3.1h5.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-0a1bbc5a-b788-4ce2-8500-fb677d294b64",
    d: "M98.9,147.1c.2,1.2,1.1,1.8,2.3,1.8s2-.8,2-1.7-.6-1.5-2.3-1.9c-2.2-.6-2.8-1.4-2.8-2.6s.9-2.5,3-2.5,3,1.2,3.1,2.6h-1.2c-.2-.9-.6-1.7-2-1.7s-1.7.6-1.7,1.5.3,1.2,2,1.7c2.3.6,3.1,1.4,3.1,2.9s-1.3,2.8-3.2,2.8-3.3-.9-3.4-2.8h1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-0a1bbc5a-b788-4ce2-8500-fb677d294b64",
    d: "M110.5,149.9l4.4-13.3h1l-4.4,13.3h-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-0a1bbc5a-b788-4ce2-8500-fb677d294b64",
    d: "M123.1,149.7v-12.9h1.7c5.6,9.7,6.4,10.9,6.6,11.4h0c-.1-1.8-.1-3.9-.1-6v-5.5h1.2v12.9h-1.5c-6-10.4-6.4-11.1-6.7-11.7h0c0,1.7,0,3.8,0,6.2v5.5h-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-0a1bbc5a-b788-4ce2-8500-fb677d294b64",
    d: "M142.8,144.9c0,2.7-1.1,5-4.1,5s-3.9-2.4-3.9-5,1.4-4.8,4.1-4.8,4,2,4,4.7ZM136,144.9c0,2.2,1,3.9,2.8,3.9s2.7-1.7,2.7-4-.9-3.7-2.8-3.7-2.8,1.6-2.8,3.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-0a1bbc5a-b788-4ce2-8500-fb677d294b64",
    d: "M143.8,140.3h1.6v-2.8h1.2v2.8h2v1h-2v6.3c0,.8.2,1.2,1,1.2s.6,0,.8,0v.9c-.3.1-.8.2-1.1.2-1.2,0-1.9-.4-1.9-1.9v-6.6h-1.6v-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-0a1bbc5a-b788-4ce2-8500-fb677d294b64",
    d: "M150.8,145.2c0,2.2.9,3.7,2.7,3.7s2.2-1.2,2.4-1.7h1.2c-.3,1-1.1,2.8-3.6,2.8s-3.8-2.4-3.8-4.9,1.1-4.8,3.9-4.8,3.7,2.3,3.7,4.4,0,.7,0,.7h-6.4ZM155.9,144.3c0-1.8-.8-3.1-2.5-3.1s-2.5,1.9-2.6,3.1h5.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-0a1bbc5a-b788-4ce2-8500-fb677d294b64",
    d: "M159.3,136.1h1.2v5.6c.4-.8,1.3-1.6,2.9-1.6,2.2,0,3.6,1.8,3.6,4.6s-1.2,5.2-3.9,5.2-2.3-.6-2.6-1.5c0,.4,0,.9,0,1.3h-1.2c0-.5,0-1.4,0-2.6v-11ZM165.8,144.8c0-2.2-.9-3.6-2.6-3.6s-2.7,1.3-2.7,3.7.5,3.9,2.7,3.9,2.7-1.7,2.7-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-0a1bbc5a-b788-4ce2-8500-fb677d294b64",
    d: "M176.5,144.9c0,2.7-1.1,5-4.1,5s-3.9-2.4-3.9-5,1.4-4.8,4.1-4.8,4,2,4,4.7ZM169.7,144.9c0,2.2,1,3.9,2.8,3.9s2.7-1.7,2.7-4-.9-3.7-2.8-3.7-2.8,1.6-2.8,3.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-0a1bbc5a-b788-4ce2-8500-fb677d294b64",
    d: "M186.1,144.9c0,2.7-1.1,5-4.1,5s-3.9-2.4-3.9-5,1.4-4.8,4.1-4.8,4,2,4,4.7ZM179.3,144.9c0,2.2,1,3.9,2.8,3.9s2.7-1.7,2.7-4-.9-3.7-2.8-3.7-2.8,1.6-2.8,3.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-0a1bbc5a-b788-4ce2-8500-fb677d294b64",
    d: "M189.4,144.9c.9-1,3.1-3.3,4.2-4.6h1.4c-1.1,1.2-2.2,2.3-3.3,3.6,1.2,1.8,2.6,4,3.8,5.8h-1.4c-.8-1.3-2.3-3.6-3.2-5-.3.4-1.1,1.1-1.5,1.5v3.6h-1.2v-13.6h1.2v8.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-0a1bbc5a-b788-4ce2-8500-fb677d294b64",
    d: "M197.5,147.1c.2,1.2,1.1,1.8,2.3,1.8s2-.8,2-1.7-.6-1.5-2.3-1.9c-2.2-.6-2.8-1.4-2.8-2.6s.9-2.5,3-2.5,3,1.2,3.1,2.6h-1.2c-.2-.9-.6-1.7-2-1.7s-1.7.6-1.7,1.5.3,1.2,2,1.7c2.3.6,3.1,1.4,3.1,2.9s-1.3,2.8-3.2,2.8-3.3-.9-3.4-2.8h1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-0a1bbc5a-b788-4ce2-8500-fb677d294b64",
    d: "M63.2,174.7c-.4,2-1.7,3.8-4.6,3.8s-5.1-2.8-5.1-6.8,1.6-6.5,5.2-6.5,4.2,1.7,4.5,3.9h-1.3c-.4-1.7-1.3-2.8-3.3-2.8s-3.9,2.6-3.9,5.5.9,5.7,3.9,5.7,2.9-1.1,3.4-2.8h1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-0a1bbc5a-b788-4ce2-8500-fb677d294b64",
    d: "M71.7,176.4c0,.7,0,1.5.1,2h-1.1c0-.3-.1-.8-.1-1.6-.3,1-1.3,1.7-2.9,1.7-2.3,0-2.9-1.6-2.9-2.8s.8-2.9,4.2-2.9h1.6v-1c0-.9-.3-2-2-2s-2,.7-2.2,1.8h-1.2c.2-1.6,1.1-2.8,3.4-2.8s3.2.8,3.2,2.9v4.8ZM70.6,173.7h-1.6c-2.5,0-3,1-3,2s.6,1.9,1.9,1.9c2,0,2.7-1.3,2.7-3.6v-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-0a1bbc5a-b788-4ce2-8500-fb677d294b64",
    d: "M74.6,178.4v-13.6h1.2v13.6h-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-0a1bbc5a-b788-4ce2-8500-fb677d294b64",
    d: "M79.1,173.9c0,2.2.9,3.7,2.7,3.7s2.2-1.2,2.4-1.7h1.2c-.3,1-1.1,2.8-3.6,2.8s-3.8-2.4-3.8-4.9,1.1-4.8,3.9-4.8,3.7,2.3,3.7,4.4,0,.7,0,.7h-6.4ZM84.3,172.9c0-1.8-.8-3.1-2.5-3.1s-2.5,1.9-2.6,3.1h5.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-0a1bbc5a-b788-4ce2-8500-fb677d294b64",
    d: "M87.7,171.9c0-2,0-2.5,0-2.9h1.2c0,.2,0,1.2,0,1.6.4-.9,1.2-1.8,2.8-1.8s3,.9,3,3.6v6h-1.2v-5.9c0-1.5-.5-2.6-2-2.6s-2.6,1.5-2.6,3.6v4.9h-1.2v-6.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-0a1bbc5a-b788-4ce2-8500-fb677d294b64",
    d: "M104.5,164.8v11.2c0,.8,0,1.8,0,2.4h-1.2c0-.2,0-.9,0-1.5-.5,1.2-1.3,1.7-2.9,1.7-2.4,0-3.6-2.1-3.6-4.9s1.4-4.9,3.9-4.9,2.3.7,2.6,1.2v-5.3h1.2ZM98.1,173.6c0,2.5,1.1,3.9,2.7,3.9,2.2,0,2.6-1.7,2.6-4s-.9-3.6-2.5-3.6-2.8,1.4-2.8,3.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-0a1bbc5a-b788-4ce2-8500-fb677d294b64",
    d: "M113.6,176.4c0,.7,0,1.5.1,2h-1.1c0-.3-.1-.8-.1-1.6-.3,1-1.3,1.7-2.9,1.7-2.3,0-2.9-1.6-2.9-2.8s.8-2.9,4.2-2.9h1.6v-1c0-.9-.3-2-2-2s-2,.7-2.2,1.8h-1.2c.2-1.6,1.1-2.8,3.4-2.8s3.2.8,3.2,2.9v4.8ZM112.5,173.7h-1.6c-2.5,0-3,1-3,2s.6,1.9,1.9,1.9c2,0,2.7-1.3,2.7-3.6v-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-0a1bbc5a-b788-4ce2-8500-fb677d294b64",
    d: "M116.5,172.2c0-1.5,0-2.8,0-3.2h1.2c0,.5,0,1.1,0,2,.5-1.3,1.6-2.2,3.1-2.2v1.3c-2.2.1-3.1,1.6-3.1,3.6v4.8h-1.2v-6.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-0a1bbc5a-b788-4ce2-8500-fb677d294b64",
    d: "M122.8,175.7c.2,1.2,1.1,1.8,2.3,1.8s2-.8,2-1.7-.6-1.5-2.3-1.9c-2.2-.6-2.8-1.4-2.8-2.6s.9-2.5,3-2.5,3,1.2,3.1,2.6h-1.2c-.2-.9-.6-1.7-2-1.7s-1.7.6-1.7,1.5.3,1.2,2,1.7c2.3.6,3.1,1.4,3.1,2.9s-1.3,2.8-3.2,2.8-3.3-.9-3.4-2.8h1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-0a1bbc5a-b788-4ce2-8500-fb677d294b64",
    d: "M145.5,170.4l-3.1,4.9c-1.7,2.6-2.5,3.3-4.4,3.3s-3.4-1.5-3.4-3.4,1.1-2.8,3.3-4.1c2-1.2,2.7-1.8,2.7-3s-.5-1.8-1.8-1.8-1.8.8-1.8,1.9.4,1.6,1.6,2.7l7.6,7.5h-1.7l-7-6.9c-1.1-1.1-1.7-2-1.7-3.2s1-2.9,3-2.9,2.9,1.2,2.9,2.8-1,2.5-3.1,3.7c-2.1,1.2-2.7,2-2.7,3.3s1,2.4,2.3,2.4,2.3-1,3.4-2.7l2.7-4.3h1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-0a1bbc5a-b788-4ce2-8500-fb677d294b64",
    d: "M155.2,166.5h-3.9v-1.1h9v1.1h-3.9v11.8h-1.2v-11.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-0a1bbc5a-b788-4ce2-8500-fb677d294b64",
    d: "M166.3,176.4c0,.7,0,1.5.1,2h-1.1c0-.3-.1-.8-.1-1.6-.3,1-1.3,1.7-2.9,1.7-2.3,0-2.9-1.6-2.9-2.8s.8-2.9,4.2-2.9h1.6v-1c0-.9-.3-2-2-2s-2,.7-2.2,1.8h-1.2c.2-1.6,1.1-2.8,3.4-2.8s3.2.8,3.2,2.9v4.8ZM165.2,173.7h-1.6c-2.5,0-3,1-3,2s.6,1.9,1.9,1.9c2,0,2.7-1.3,2.7-3.6v-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-0a1bbc5a-b788-4ce2-8500-fb677d294b64",
    d: "M169.1,164.8h1.2v5.6c.4-.8,1.3-1.6,2.9-1.6,2.2,0,3.6,1.8,3.6,4.6s-1.2,5.2-3.9,5.2-2.3-.6-2.6-1.5c0,.4,0,.9,0,1.3h-1.2c0-.5,0-1.4,0-2.6v-11ZM175.6,173.4c0-2.2-.9-3.6-2.6-3.6s-2.7,1.3-2.7,3.7.5,3.9,2.7,3.9,2.7-1.7,2.7-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-0a1bbc5a-b788-4ce2-8500-fb677d294b64",
    d: "M179,178.4v-13.6h1.2v13.6h-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-0a1bbc5a-b788-4ce2-8500-fb677d294b64",
    d: "M183.6,173.9c0,2.2.9,3.7,2.7,3.7s2.2-1.2,2.4-1.7h1.2c-.3,1-1.1,2.8-3.6,2.8s-3.8-2.4-3.8-4.9,1.1-4.8,3.9-4.8,3.7,2.3,3.7,4.4,0,.7,0,.7h-6.4ZM188.8,172.9c0-1.8-.8-3.1-2.5-3.1s-2.5,1.9-2.6,3.1h5.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-0a1bbc5a-b788-4ce2-8500-fb677d294b64",
    d: "M199.3,166.5h-3.9v-1.1h9v1.1h-3.9v11.8h-1.2v-11.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-0a1bbc5a-b788-4ce2-8500-fb677d294b64",
    d: "M211.5,173.5c0,2.7-1.1,5-4.1,5s-3.9-2.4-3.9-5,1.4-4.8,4.1-4.8,4,2,4,4.7ZM204.7,173.5c0,2.2,1,3.9,2.8,3.9s2.7-1.7,2.7-4-.9-3.7-2.8-3.7-2.8,1.6-2.8,3.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-0a1bbc5a-b788-4ce2-8500-fb677d294b64",
    d: "M214.9,177.1v5h-1.2v-10.4c0-1.3,0-2.2,0-2.8h1.2c0,.3,0,1.1,0,1.6.5-1.1,1.5-1.8,3-1.8s3.5,1.7,3.5,4.7-1.7,5-3.8,5-2.2-.6-2.7-1.4ZM220.1,173.5c0-2.3-1-3.7-2.6-3.7s-2.7,1.5-2.7,3.9.4,3.8,2.6,3.8,2.7-1.4,2.7-3.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-0a1bbc5a-b788-4ce2-8500-fb677d294b64",
    d: "M237.7,174.7c-.4,2-1.7,3.8-4.6,3.8s-5.1-2.8-5.1-6.8,1.6-6.5,5.2-6.5,4.2,1.7,4.5,3.9h-1.3c-.4-1.7-1.3-2.8-3.3-2.8s-3.9,2.6-3.9,5.5.9,5.7,3.9,5.7,2.9-1.1,3.4-2.8h1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-0a1bbc5a-b788-4ce2-8500-fb677d294b64",
    d: "M246.3,176.4c0,.7,0,1.5.1,2h-1.1c0-.3-.1-.8-.1-1.6-.3,1-1.3,1.7-2.9,1.7-2.3,0-2.9-1.6-2.9-2.8s.8-2.9,4.2-2.9h1.6v-1c0-.9-.3-2-2-2s-2,.7-2.2,1.8h-1.2c.2-1.6,1.1-2.8,3.4-2.8s3.2.8,3.2,2.9v4.8ZM245.1,173.7h-1.6c-2.5,0-3,1-3,2s.6,1.9,1.9,1.9c2,0,2.7-1.3,2.7-3.6v-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-0a1bbc5a-b788-4ce2-8500-fb677d294b64",
    d: "M249.1,178.4v-13.6h1.2v13.6h-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-0a1bbc5a-b788-4ce2-8500-fb677d294b64",
    d: "M253.7,173.9c0,2.2.9,3.7,2.7,3.7s2.2-1.2,2.4-1.7h1.2c-.3,1-1.1,2.8-3.6,2.8s-3.8-2.4-3.8-4.9,1.1-4.8,3.9-4.8,3.7,2.3,3.7,4.4,0,.7,0,.7h-6.4ZM258.9,172.9c0-1.8-.8-3.1-2.5-3.1s-2.5,1.9-2.6,3.1h5.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-0a1bbc5a-b788-4ce2-8500-fb677d294b64",
    d: "M262.2,171.9c0-2,0-2.5,0-2.9h1.2c0,.2,0,1.2,0,1.6.4-.9,1.2-1.8,2.8-1.8s3,.9,3,3.6v6h-1.2v-5.9c0-1.5-.5-2.6-2-2.6s-2.6,1.5-2.6,3.6v4.9h-1.2v-6.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-0a1bbc5a-b788-4ce2-8500-fb677d294b64",
    d: "M279.1,164.8v11.2c0,.8,0,1.8,0,2.4h-1.2c0-.2,0-.9,0-1.5-.5,1.2-1.3,1.7-2.9,1.7-2.4,0-3.6-2.1-3.6-4.9s1.4-4.9,3.9-4.9,2.3.7,2.6,1.2v-5.3h1.2ZM272.7,173.6c0,2.5,1.1,3.9,2.7,3.9,2.2,0,2.6-1.7,2.6-4s-.9-3.6-2.5-3.6-2.8,1.4-2.8,3.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-0a1bbc5a-b788-4ce2-8500-fb677d294b64",
    d: "M288.2,176.4c0,.7,0,1.5.1,2h-1.1c0-.3-.1-.8-.1-1.6-.3,1-1.3,1.7-2.9,1.7-2.3,0-2.9-1.6-2.9-2.8s.8-2.9,4.2-2.9h1.6v-1c0-.9-.3-2-2-2s-2,.7-2.2,1.8h-1.2c.2-1.6,1.1-2.8,3.4-2.8s3.2.8,3.2,2.9v4.8ZM287.1,173.7h-1.6c-2.5,0-3,1-3,2s.6,1.9,1.9,1.9c2,0,2.7-1.3,2.7-3.6v-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-0a1bbc5a-b788-4ce2-8500-fb677d294b64",
    d: "M291.1,172.2c0-1.5,0-2.8,0-3.2h1.2c0,.5,0,1.1,0,2,.5-1.3,1.6-2.2,3.1-2.2v1.3c-2.2.1-3.1,1.6-3.1,3.6v4.8h-1.2v-6.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-0a1bbc5a-b788-4ce2-8500-fb677d294b64",
    d: "M297.4,175.7c.2,1.2,1.1,1.8,2.3,1.8s2-.8,2-1.7-.6-1.5-2.3-1.9c-2.2-.6-2.8-1.4-2.8-2.6s.9-2.5,3-2.5,3,1.2,3.1,2.6h-1.2c-.2-.9-.6-1.7-2-1.7s-1.7.6-1.7,1.5.3,1.2,2,1.7c2.3.6,3.1,1.4,3.1,2.9s-1.3,2.8-3.2,2.8-3.3-.9-3.4-2.8h1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-0a1bbc5a-b788-4ce2-8500-fb677d294b64",
    d: "M54.1,194.1h4.3c2.1,0,3.7,1.1,3.7,3.2s-1.1,2.5-1.9,2.7c.9.3,2.4,1.1,2.4,3.3s-1.8,3.8-4.3,3.8h-4.1v-12.9ZM58.1,199.5c2,0,2.8-.9,2.8-2.2s-.8-2.2-2.6-2.2h-2.9v4.4h2.8ZM55.3,206h2.8c1.8,0,3.1-.9,3.1-2.7s-1.1-2.7-3.3-2.7h-2.7v5.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-0a1bbc5a-b788-4ce2-8500-fb677d294b64",
    d: "M71.1,205c0,.7,0,1.5.1,2h-1.1c0-.3-.1-.8-.1-1.6-.3,1-1.3,1.7-2.9,1.7-2.3,0-2.9-1.6-2.9-2.8s.8-2.9,4.2-2.9h1.6v-1c0-.9-.3-2-2-2s-2,.7-2.2,1.8h-1.2c.2-1.6,1.1-2.8,3.4-2.8s3.2.8,3.2,2.9v4.8ZM70,202.3h-1.6c-2.5,0-3,1-3,2s.6,1.9,1.9,1.9c2,0,2.7-1.3,2.7-3.6v-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-0a1bbc5a-b788-4ce2-8500-fb677d294b64",
    d: "M80.9,206.4c0,2.9-1.2,4.5-3.9,4.5s-3.4-1.4-3.6-2.7h1.2c.2,1.2,1.2,1.7,2.4,1.7,2.2,0,2.7-1.5,2.7-3.7v-.8c-.5,1.1-1.3,1.7-2.9,1.7s-3.6-1.9-3.6-4.8,1.7-4.9,3.8-4.9,2.3.6,2.6,1.4c0-.5,0-1,0-1.3h1.2c0,.4,0,1.4,0,2.7v6.1ZM74.6,202.3c0,2.4,1,3.7,2.6,3.7s2.6-1.2,2.6-3.8-.6-3.7-2.5-3.7-2.7,1.5-2.7,3.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-0a1bbc5a-b788-4ce2-8500-fb677d294b64",
    d: "M83.9,204.3c.2,1.2,1.1,1.8,2.3,1.8s2-.8,2-1.7-.6-1.5-2.3-1.9c-2.2-.6-2.8-1.4-2.8-2.6s.9-2.5,3-2.5,3,1.2,3.1,2.6h-1.2c-.2-.9-.6-1.7-2-1.7s-1.7.6-1.7,1.5.3,1.2,2,1.7c2.3.6,3.1,1.4,3.1,2.9s-1.3,2.8-3.2,2.8-3.3-.9-3.4-2.8h1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-0a1bbc5a-b788-4ce2-8500-fb677d294b64",
    d: "M95.6,207.2l4.4-13.3h1l-4.4,13.3h-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-0a1bbc5a-b788-4ce2-8500-fb677d294b64",
    d: "M110.3,207l-3.3-12.9h1.3c1.5,6.1,2.4,9.7,2.7,11.5h0c.2-1.5,2.1-8.3,2.9-11.5h1.2c.8,3.1,2.6,10,2.8,11.5h0c.4-2.2,2.2-8.5,2.9-11.5h1.2l-3.6,12.9h-1.4c-.8-3-2.5-9.6-2.7-11.3h0c-.3,1.9-2,8.2-2.8,11.3h-1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-0a1bbc5a-b788-4ce2-8500-fb677d294b64",
    d: "M129.4,205c0,.7,0,1.5.1,2h-1.1c0-.3-.1-.8-.1-1.6-.3,1-1.3,1.7-2.9,1.7-2.3,0-2.9-1.6-2.9-2.8s.8-2.9,4.2-2.9h1.6v-1c0-.9-.3-2-2-2s-2,.7-2.2,1.8h-1.2c.2-1.6,1.1-2.8,3.4-2.8s3.2.8,3.2,2.9v4.8ZM128.3,202.3h-1.6c-2.5,0-3,1-3,2s.6,1.9,1.9,1.9c2,0,2.7-1.3,2.7-3.6v-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-0a1bbc5a-b788-4ce2-8500-fb677d294b64",
    d: "M130.7,197.6h1.6v-2.8h1.2v2.8h2v1h-2v6.3c0,.8.2,1.2,1,1.2s.6,0,.8,0v.9c-.3.1-.8.2-1.1.2-1.2,0-1.9-.4-1.9-1.9v-6.6h-1.6v-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-0a1bbc5a-b788-4ce2-8500-fb677d294b64",
    d: "M137.7,202.5c0,2.2.9,3.7,2.7,3.7s2.2-1.2,2.4-1.7h1.2c-.3,1-1.1,2.8-3.6,2.8s-3.8-2.4-3.8-4.9,1.1-4.8,3.9-4.8,3.7,2.3,3.7,4.4,0,.7,0,.7h-6.4ZM142.9,201.5c0-1.8-.8-3.1-2.5-3.1s-2.5,1.9-2.6,3.1h5.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-0a1bbc5a-b788-4ce2-8500-fb677d294b64",
    d: "M146.2,200.8c0-1.5,0-2.8,0-3.2h1.2c0,.5,0,1.1,0,2,.5-1.3,1.6-2.2,3.1-2.2v1.3c-2.2.1-3.1,1.6-3.1,3.6v4.8h-1.2v-6.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-0a1bbc5a-b788-4ce2-8500-fb677d294b64",
    d: "M156.8,193.4h1.2v5.6c.4-.8,1.3-1.6,2.9-1.6,2.2,0,3.6,1.8,3.6,4.6s-1.2,5.2-3.9,5.2-2.3-.6-2.6-1.5c0,.4,0,.9,0,1.3h-1.2c0-.5,0-1.4,0-2.6v-11ZM163.2,202.1c0-2.2-.9-3.6-2.6-3.6s-2.7,1.3-2.7,3.7.5,3.9,2.7,3.9,2.7-1.7,2.7-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-0a1bbc5a-b788-4ce2-8500-fb677d294b64",
    d: "M174,202.1c0,2.7-1.1,5-4.1,5s-3.9-2.4-3.9-5,1.4-4.8,4.1-4.8,4,2,4,4.7ZM167.2,202.2c0,2.2,1,3.9,2.8,3.9s2.7-1.7,2.7-4-.9-3.7-2.8-3.7-2.8,1.6-2.8,3.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-0a1bbc5a-b788-4ce2-8500-fb677d294b64",
    d: "M174.9,197.6h1.6v-2.8h1.2v2.8h2v1h-2v6.3c0,.8.2,1.2,1,1.2s.6,0,.8,0v.9c-.3.1-.8.2-1.1.2-1.2,0-1.9-.4-1.9-1.9v-6.6h-1.6v-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-0a1bbc5a-b788-4ce2-8500-fb677d294b64",
    d: "M180,197.6h1.6v-2.8h1.2v2.8h2v1h-2v6.3c0,.8.2,1.2,1,1.2s.6,0,.8,0v.9c-.3.1-.8.2-1.1.2-1.2,0-1.9-.4-1.9-1.9v-6.6h-1.6v-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-0a1bbc5a-b788-4ce2-8500-fb677d294b64",
    d: "M186.4,207v-13.6h1.2v13.6h-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-0a1bbc5a-b788-4ce2-8500-fb677d294b64",
    d: "M191,202.5c0,2.2.9,3.7,2.7,3.7s2.2-1.2,2.4-1.7h1.2c-.3,1-1.1,2.8-3.6,2.8s-3.8-2.4-3.8-4.9,1.1-4.8,3.9-4.8,3.7,2.3,3.7,4.4,0,.7,0,.7h-6.4ZM196.2,201.5c0-1.8-.8-3.1-2.5-3.1s-2.5,1.9-2.6,3.1h5.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-0a1bbc5a-b788-4ce2-8500-fb677d294b64",
    d: "M199.9,204.3c.2,1.2,1.1,1.8,2.3,1.8s2-.8,2-1.7-.6-1.5-2.3-1.9c-2.2-.6-2.8-1.4-2.8-2.6s.9-2.5,3-2.5,3,1.2,3.1,2.6h-1.2c-.2-.9-.6-1.7-2-1.7s-1.7.6-1.7,1.5.3,1.2,2,1.7c2.3.6,3.1,1.4,3.1,2.9s-1.3,2.8-3.2,2.8-3.3-.9-3.4-2.8h1.2Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "uuid-dee9cec7-f176-469b-80bb-bc3fd90fd066",
    x1: 400,
    y1: 56.3,
    x2: 53.1,
    y2: 56.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-1dcdb0a8-3b20-4c1c-95c7-f47a7168dde0",
    d: "M46.8,326.2c-2.1,0-3.8-1.7-3.8-3.8s1.7-3.8,3.8-3.8,3.8,1.7,3.8,3.8-1.7,3.8-3.8,3.8ZM46.8,318.7c-2,0-3.7,1.6-3.7,3.7s1.6,3.7,3.7,3.7,3.7-1.6,3.7-3.7-1.6-3.7-3.7-3.7Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "uuid-1dcdb0a8-3b20-4c1c-95c7-f47a7168dde0",
    cx: 46.8,
    cy: 322.3,
    r: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-1dcdb0a8-3b20-4c1c-95c7-f47a7168dde0",
    d: "M48,370.8c0,.6-.5,1.1-1.1,1.1s-1.1-.5-1.1-1.1.5-1.1,1.1-1.1,1.1.5,1.1,1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-1dcdb0a8-3b20-4c1c-95c7-f47a7168dde0",
    d: "M141.2,311h-1.4c0-10.3,2.7-20.4,7.8-29.2l1.2.7c-5,8.6-7.6,18.5-7.6,28.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-1dcdb0a8-3b20-4c1c-95c7-f47a7168dde0",
    d: "M148,340c-5.1-8.8-7.8-18.8-7.8-29.1h.7c0,10.1,2.7,20,7.7,28.7l-.6.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-1dcdb0a8-3b20-4c1c-95c7-f47a7168dde0",
    d: "M197.9,368.7c0-.2.2-.4.4-.4h0c.2,0,.4.2.4.4h0c0,.2-.2.4-.4.4h0c-.2,0-.4-.2-.4-.4ZM196.2,369.1c-.2,0-.3-.2-.3-.4h0c0-.2.2-.3.4-.3h0c.2,0,.3.2.3.4h0c0,.2-.2.3-.4.3h0ZM194.1,368.9h0c-.2,0-.3-.2-.3-.4h0c0-.2.2-.3.4-.3h0c.2,0,.3.2.3.4h0c0,.2-.2.3-.4.3h0s0,0,0,0ZM192,368.8c-.2,0-.3-.2-.3-.4h0c0-.2.2-.3.4-.3h0c.2,0,.3.2.3.4h0c0,.2-.2.3-.3.3h0s0,0,0,0ZM189.8,368.5h0c-.2,0-.3-.2-.3-.4h0c0-.2.2-.3.4-.3h0c.2,0,.3.2.3.4h0c0,.2-.2.3-.3.3h0s0,0,0,0ZM187.8,368.1h0c-.2,0-.3-.2-.3-.4h0c0-.2.2-.3.4-.3h0c.2,0,.3.2.3.4h0c0,.2-.2.3-.3.3h0s0,0,0,0ZM185.7,367.7c-.2,0-.3-.2-.3-.4h0c0-.2.2-.3.4-.3h0c.2,0,.3.2.3.4h0c0,.2-.2.3-.3.3h0s0,0,0,0ZM183.6,367.2c-.2,0-.3-.2-.3-.4h0c0-.2.2-.3.4-.3h0c.2,0,.3.2.3.4h0c0,.2-.2.3-.3.3h0s0,0,0,0ZM181.6,366.7h0c-.2,0-.3-.3-.2-.4h0c0-.2.2-.3.4-.2h0c.2,0,.3.3.2.4h0c0,.2-.2.2-.3.2h0s0,0-.1,0ZM179.6,366c-.2,0-.3-.3-.2-.4h0c0-.2.3-.3.4-.2h0c.2,0,.3.3.2.4h0c0,.1-.2.2-.3.2h0s0,0-.1,0ZM177.6,365.3c-.2,0-.3-.3-.2-.5h0c0-.2.3-.3.5-.2h0c.2,0,.3.3.2.5h0c0,.1-.2.2-.3.2h0s0,0-.1,0ZM175.6,364.5c-.2,0-.3-.3-.2-.5h0c0-.2.3-.3.5-.2h0c.2,0,.3.3.2.5h0c0,.1-.2.2-.3.2h0s0,0-.1,0ZM173.7,363.6c-.2,0-.2-.3-.2-.5h0c0-.2.3-.3.5-.2h0c.2,0,.3.3.2.5h0c0,.1-.2.2-.3.2h0s-.1,0-.2,0ZM171.8,362.7h0c-.2,0-.2-.3-.2-.5h0c0-.2.3-.2.5-.2h0c.2,0,.2.3.2.5h0c0,.1-.2.2-.3.2h0c0,0-.1,0-.2,0ZM169.9,361.7c-.2,0-.2-.3-.1-.5h0c0-.2.3-.2.5-.1h0c.2,0,.2.3.1.5h0c0,.1-.2.2-.3.2h0c0,0-.1,0-.2,0ZM168.1,360.6h0c-.2-.1-.2-.3-.1-.5h0c.1-.2.3-.2.5-.1h0c.2,0,.2.3.1.5h0c0,.1-.2.2-.3.2h0c0,0-.1,0-.2,0ZM166.3,359.5c-.2-.1-.2-.3,0-.5h0c.1-.2.3-.2.5-.1h0c.2.1.2.3,0,.5h0c0,.1-.2.2-.3.2h0c0,0-.1,0-.2,0ZM164.5,358.3h0c-.2-.1-.2-.3,0-.5h0c.1-.2.3-.2.5,0h0c.2.1.2.3,0,.5h0c0,0-.2.1-.3.1h0c0,0-.1,0-.2,0ZM162.8,357c-.2-.1-.2-.3,0-.5h0c.1-.2.3-.2.5,0h0c.2.1.2.3,0,.5h0c0,0-.2.1-.3.1h0c0,0-.1,0-.2,0ZM161.2,355.7c-.1-.1-.2-.3,0-.5h0c.1-.2.3-.2.5,0h0c.1.1.2.3,0,.5h0c0,0-.2.1-.3.1h0c0,0-.2,0-.2,0ZM159.6,354.3c-.1-.1-.2-.4,0-.5h0c.1-.1.4-.2.5,0h0c.1.1.2.4,0,.5h0c0,0-.2.1-.3.1h0c0,0-.2,0-.2,0ZM158,352.9c-.1-.1-.1-.4,0-.5h0c.1-.1.4-.1.5,0h0c.1.1.1.4,0,.5h0c0,0-.2.1-.3.1h0c0,0-.2,0-.2,0ZM156.5,351.4c-.1-.1-.1-.4,0-.5h0c.1-.1.4-.1.5,0h0c.1.1.1.4,0,.5h0c0,0-.2,0-.2,0h0c0,0-.2,0-.3-.1ZM155.1,349.8h0c-.1-.1-.1-.4,0-.5h0c.1-.1.4-.1.5,0h0c.1.1.1.4,0,.5h0c0,0-.2,0-.2,0h0c0,0-.2,0-.3-.1ZM153.7,348.2h0c-.1-.1-.1-.4,0-.5h0c.1-.1.4-.1.5,0h0c.1.2.1.4,0,.5h0c0,0-.1,0-.2,0h0c0,0-.2,0-.3-.1ZM152.3,346.6c-.1-.2,0-.4,0-.5h0c.2-.1.4,0,.5,0h0c.1.2,0,.4,0,.5h0c0,0-.1,0-.2,0h0c-.1,0-.2,0-.3-.1ZM151.1,344.9c-.1-.2,0-.4,0-.5h0c.2-.1.4,0,.5,0h0c.1.2,0,.4,0,.5h0c0,0-.1,0-.2,0h0c-.1,0-.2,0-.3-.1ZM149.9,343.1h0c-.1-.2,0-.4,0-.5h0c.2-.1.4,0,.5,0h0c.1.2,0,.4,0,.5h0c0,0-.1,0-.2,0h0c-.1,0-.2,0-.3-.2ZM148.7,341.4h0c-.1-.2,0-.4.1-.5h0c.2-.1.4,0,.5.1h0c.1.2,0,.4-.1.5h0c0,0-.1,0-.2,0h0c-.1,0-.2,0-.3-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-1dcdb0a8-3b20-4c1c-95c7-f47a7168dde0",
    d: "M198.3,368.9v-.4c10.3,0,20.4-2.7,29.2-7.9,8.6-5,15.7-12.3,20.7-20.9l.3.2c-5,8.6-12.2,15.9-20.8,21-8.9,5.2-19,8-29.4,8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-1dcdb0a8-3b20-4c1c-95c7-f47a7168dde0",
    d: "M148.4,282.2l-.3-.2c5-8.6,12.2-15.9,20.8-21,8.9-5.2,19-8,29.4-8v.4c-10.3,0-20.4,2.7-29.2,7.9-8.6,5-15.7,12.3-20.7,20.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-1dcdb0a8-3b20-4c1c-95c7-f47a7168dde0",
    d: "M247.7,282.4c-4.9-8.5-12-15.7-20.5-20.7-8.7-5.1-18.7-7.9-28.9-7.9v-1.4c10.4,0,20.7,2.8,29.6,8.1,8.7,5.1,15.9,12.4,21,21.2l-1.2.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-1dcdb0a8-3b20-4c1c-95c7-f47a7168dde0",
    d: "M250,282.9c0-.7-.6-1.2-1.2-1.2s-1.2.6-1.2,1.2.6,1.2,1.2,1.2,1.2-.6,1.2-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-1dcdb0a8-3b20-4c1c-95c7-f47a7168dde0",
    d: "M141.8,311.2c0-.7-.6-1.2-1.2-1.2s-1.2.6-1.2,1.2.6,1.2,1.2,1.2,1.2-.6,1.2-1.2Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "uuid-1dcdb0a8-3b20-4c1c-95c7-f47a7168dde0",
    cx: 148.3,
    cy: 339.8,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-1dcdb0a8-3b20-4c1c-95c7-f47a7168dde0",
    d: "M249,340.4c-.9,0-1.6-.7-1.6-1.6s.7-1.6,1.6-1.6,1.6.7,1.6,1.6-.7,1.6-1.6,1.6ZM249,337.9c-.5,0-.9.4-.9.9s.4.9.9.9.9-.4.9-.9-.4-.9-.9-.9Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "uuid-1dcdb0a8-3b20-4c1c-95c7-f47a7168dde0",
    x: 198.1,
    y: 368.7,
    width: 0.4,
    height: 7.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-1dcdb0a8-3b20-4c1c-95c7-f47a7168dde0",
    d: "M231.8,358.6c0-.4-.3-.8-.8-.8s-.8.3-.8.8.3.8.8.8.8-.3.8-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-1dcdb0a8-3b20-4c1c-95c7-f47a7168dde0",
    d: "M198.3,379.4c-.8,0-1.5-.7-1.5-1.5s.7-1.5,1.5-1.5,1.5.7,1.5,1.5-.7,1.5-1.5,1.5ZM198.3,376.7c-.6,0-1.2.5-1.2,1.2s.5,1.2,1.2,1.2,1.2-.5,1.2-1.2-.5-1.2-1.2-1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-0a1bbc5a-b788-4ce2-8500-fb677d294b64",
    d: "M198.8,377.9c0-.3-.2-.5-.5-.5s-.5.2-.5.5.2.5.5.5.5-.2.5-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-1dcdb0a8-3b20-4c1c-95c7-f47a7168dde0",
    d: "M199.1,368.7c0-.4-.3-.8-.8-.8s-.8.3-.8.8.3.8.8.8.8-.3.8-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-1dcdb0a8-3b20-4c1c-95c7-f47a7168dde0",
    d: "M137.6,491.5c-12.7,0-25.4-4.8-35.1-14.5l1-1c18.8,18.8,49.4,18.8,68.2,0l1,1c-9.7,9.7-22.4,14.5-35.1,14.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-1dcdb0a8-3b20-4c1c-95c7-f47a7168dde0",
    d: "M172.7,476c-.1-.1-.1-.4,0-.5h0c.1-.1.4-.1.5,0h0c.1.1.1.4,0,.5h0c0,0-.2.1-.3.1h0c0,0-.2,0-.2,0ZM174.2,474.4c-.1-.1-.2-.4,0-.5h0c.1-.1.3-.2.5,0h0c.1.1.2.3,0,.5h0c0,0-.2.1-.3.1h0c0,0-.2,0-.2,0ZM175.5,472.8c-.2-.1-.2-.3,0-.5h0c.1-.2.3-.2.5,0h0c.2.1.2.3,0,.5h0c0,0-.2.1-.3.1h0c0,0-.2,0-.2,0ZM176.8,471.2c-.2-.1-.2-.3,0-.5h0c.1-.2.3-.2.5,0h0c.2.1.2.3,0,.5h0c0,0-.2.1-.3.1h0c0,0-.1,0-.2,0ZM178.1,469.5c-.2-.1-.2-.3,0-.5h0c.1-.2.3-.2.5,0h0c.2.1.2.3,0,.5h0c0,.1-.2.2-.3.2h0c0,0-.1,0-.2,0ZM179.2,467.7c-.2-.1-.2-.3-.1-.5h0c.1-.2.3-.2.5-.1h0c.2.1.2.3.1.5h0c0,.1-.2.2-.3.2h0c0,0-.1,0-.2,0ZM180.3,465.9c-.2,0-.2-.3-.1-.5h0c0-.2.3-.2.5-.1h0c.2,0,.2.3.1.5h0c0,.1-.2.2-.3.2h0c0,0-.1,0-.2,0ZM181.3,464c-.2,0-.2-.3-.2-.5h0c0-.2.3-.2.5-.2h0c.2,0,.2.3.2.5h0c0,.1-.2.2-.3.2h0c0,0-.1,0-.2,0ZM182.2,462.1c-.2,0-.3-.3-.2-.5h0c0-.2.3-.3.5-.2h0c.2,0,.3.3.2.5h0c0,.1-.2.2-.3.2h0s0,0-.1,0ZM183,460.2c-.2,0-.3-.3-.2-.5h0c0-.2.3-.3.5-.2h0c.2,0,.3.3.2.5h0c0,.1-.2.2-.3.2h0s0,0-.1,0ZM183.8,458.2c-.2,0-.3-.3-.2-.4h0c0-.2.3-.3.4-.2h0c.2,0,.3.3.2.4h0c0,.1-.2.2-.3.2h0s0,0-.1,0ZM184.4,456.2c-.2,0-.3-.3-.2-.4h0c0-.2.3-.3.4-.2h0c.2,0,.3.3.2.4h0c0,.2-.2.2-.3.2h0s0,0,0,0ZM185,454.2c-.2,0-.3-.2-.3-.4h0c0-.2.2-.3.4-.3h0c.2,0,.3.2.3.4h0c0,.2-.2.3-.3.3h0s0,0,0,0ZM185.5,452.2c-.2,0-.3-.2-.3-.4h0c0-.2.2-.3.4-.3h0c.2,0,.3.2.3.4h0c0,.2-.2.3-.3.3h0s0,0,0,0ZM185.9,450.1c-.2,0-.3-.2-.3-.4h0c0-.2.2-.3.4-.3h0c.2,0,.3.2.3.4h0c0,.2-.2.3-.3.3h0s0,0,0,0ZM186.2,448c-.2,0-.3-.2-.3-.4h0c0-.2.2-.3.4-.3h0c.2,0,.3.2.3.4h0c0,.2-.2.3-.3.3h0s0,0,0,0ZM186.4,445.9c-.2,0-.3-.2-.3-.4h0c0-.2.2-.3.4-.3h0c.2,0,.3.2.3.4h0c0,.2-.2.3-.4.3h0ZM186.5,443.8c-.2,0-.3-.2-.3-.4h0c0-.2.2-.3.4-.3h0c.2,0,.3.2.3.4h0c0,.2-.2.3-.4.3h0ZM186.2,441.4c0-.2.2-.4.3-.4h0c.2,0,.4.2.4.3h0c0,.2-.2.4-.3.4h0c-.2,0-.3-.2-.4-.3ZM186.1,439.3h0c0-.2.1-.4.3-.4h0c.2,0,.4.1.4.3h0c0,.2-.1.4-.3.4h0c-.2,0-.3-.1-.4-.3ZM186,437.2c0-.2.1-.4.3-.4h0c.2,0,.4.1.4.3h0c0,.2-.1.4-.3.4h0s0,0,0,0h0c-.2,0-.3-.1-.3-.3ZM185.7,435.1c0-.2.1-.4.3-.4h0c.2,0,.4.1.4.3h0c0,.2-.1.4-.3.4h0s0,0,0,0h0c-.2,0-.3-.1-.3-.3ZM185.4,433h0c0-.2,0-.4.3-.4h0c.2,0,.4,0,.4.3h0c0,.2,0,.4-.3.4h0s0,0,0,0h0c-.2,0-.3-.1-.3-.3ZM185,431h0c0-.2,0-.4.3-.4h0c.2,0,.4,0,.4.3h0c0,.2,0,.4-.3.4h0s0,0,0,0h0c-.2,0-.3-.1-.3-.3ZM184.5,429c0-.2,0-.4.2-.4h0c.2,0,.4,0,.4.2h0c0,.2,0,.4-.2.4h0s0,0,0,0h0c-.2,0-.3-.1-.3-.3ZM183.9,427h0c0-.2,0-.4.2-.4h0c.2,0,.4,0,.4.2h0c0,.2,0,.4-.2.4h0s0,0-.1,0h0c-.1,0-.3,0-.3-.2ZM183.2,425c0-.2,0-.4.2-.5h0c.2,0,.4,0,.5.2h0c0,.2,0,.4-.2.4h0s0,0-.1,0h0c-.1,0-.3,0-.3-.2ZM182.4,423h0c0-.2,0-.4.2-.5h0c.2,0,.4,0,.5.2h0c0,.2,0,.4-.2.5h0s0,0-.1,0h0c-.1,0-.3,0-.3-.2ZM181.6,421.1c0-.2,0-.4.2-.5h0c.2,0,.4,0,.5.2h0c0,.2,0,.4-.2.5h0s-.1,0-.2,0h0c-.1,0-.3,0-.3-.2ZM180.6,419.3h0c0-.2,0-.4.1-.5h0c.2,0,.4,0,.5.1h0c0,.2,0,.4-.1.5h0c0,0-.1,0-.2,0h0c-.1,0-.2,0-.3-.2ZM179.6,417.4h0c0-.2,0-.4.1-.5h0c.2,0,.4,0,.5.1h0c0,.2,0,.4-.1.5h0c0,0-.1,0-.2,0h0c-.1,0-.2,0-.3-.2ZM178.5,415.7c-.1-.2,0-.4.1-.5h0c.2-.1.4,0,.5.1h0c.1.2,0,.4-.1.5h0c0,0-.1,0-.2,0h0c-.1,0-.2,0-.3-.2ZM177.4,413.9h0c-.1-.2,0-.4,0-.5h0c.2-.1.4,0,.5,0h0c.1.2,0,.4,0,.5h0c0,0-.1,0-.2,0h0c-.1,0-.2,0-.3-.2ZM176.1,412.2c-.1-.2,0-.4,0-.5h0c.2-.1.4,0,.5,0h0c.1.2,0,.4,0,.5h0c0,0-.1,0-.2,0h0c-.1,0-.2,0-.3-.1ZM174.8,410.6c-.1-.1-.1-.4,0-.5h0c.2-.1.4-.1.5,0h0c.1.1.1.4,0,.5h0c0,0-.1,0-.2,0h0c0,0-.2,0-.3-.1ZM173.4,409c-.1-.1-.1-.4,0-.5h0c.1-.1.4-.1.5,0h0c.1.1.1.4,0,.5h0c0,0-.2,0-.2,0h0c0,0-.2,0-.3-.1ZM172,407.5c-.1-.1-.1-.4,0-.5h0c.1-.1.4-.1.5,0h0c.1.1.1.4,0,.5h0c0,0-.2.1-.2.1h0c0,0-.2,0-.2-.1ZM172,407.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-1dcdb0a8-3b20-4c1c-95c7-f47a7168dde0",
    d: "M172.1,407.4c-19-19-49.9-19-69,0l-.2-.2c19.1-19.1,50.3-19.1,69.5,0l-.2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-1dcdb0a8-3b20-4c1c-95c7-f47a7168dde0",
    d: "M102.9,476.6c-19.1-19.1-19.1-50.3,0-69.5l.2.2c-19,19-19,49.9,0,69l-.2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-1dcdb0a8-3b20-4c1c-95c7-f47a7168dde0",
    d: "M89.8,298c0,.5-.4,1-1,1s-1-.4-1-1,.4-1,1-1,1,.4,1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-1dcdb0a8-3b20-4c1c-95c7-f47a7168dde0",
    d: "M46.9,322.3l-.3-.2c8.7-15,24.9-24.4,42.2-24.4v.4c-17.2,0-33.3,9.3-41.9,24.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-1dcdb0a8-3b20-4c1c-95c7-f47a7168dde0",
    d: "M46,371.3c-4.3-7.5-6.6-16-6.6-24.7s2.3-17.2,6.6-24.7l1.5.9c-4.2,7.2-6.4,15.5-6.4,23.8s2.2,16.6,6.4,23.8l-1.5.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-1dcdb0a8-3b20-4c1c-95c7-f47a7168dde0",
    d: "M88.8,395.8v-1.4c17,0,32.9-9.2,41.5-23.9l1.2.7c-8.8,15.2-25.1,24.6-42.7,24.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-1dcdb0a8-3b20-4c1c-95c7-f47a7168dde0",
    d: "M131.1,370.9l-.3-.2c4.2-7.3,6.5-15.7,6.5-24.2s-2.2-16.9-6.5-24.2l.3-.2c4.3,7.4,6.5,15.8,6.5,24.4s-2.3,17-6.5,24.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-1dcdb0a8-3b20-4c1c-95c7-f47a7168dde0",
    d: "M88.5,395.4c-.2,0-.4-.2-.3-.4h0c0-.2.2-.4.4-.3h0c.2,0,.4.2.4.4h0c0,.2-.2.4-.4.4h0ZM86.4,395.4c-.2,0-.3-.2-.3-.4h0c0-.2.2-.3.4-.3h0c.2,0,.3.2.3.4h0c0,.2-.2.3-.4.3h0ZM84.2,395.2c-.2,0-.3-.2-.3-.4h0c0-.2.2-.3.4-.3h0c.2,0,.3.2.3.4h0c0,.2-.2.3-.3.3h0ZM82.1,395h0c-.2,0-.3-.2-.3-.4h0c0-.2.2-.3.4-.3h0c.2,0,.3.2.3.4h0c0,.2-.2.3-.3.3h0s0,0,0,0ZM80,394.7h0c-.2,0-.3-.2-.3-.4h0c0-.2.2-.3.4-.3h0c.2,0,.3.2.3.4h0c0,.2-.2.3-.3.3h0s0,0,0,0ZM78,394.2c-.2,0-.3-.2-.3-.4h0c0-.2.2-.3.4-.3h0c.2,0,.3.2.3.4h0c0,.2-.2.3-.3.3h0s0,0,0,0ZM75.9,393.7c-.2,0-.3-.2-.2-.4h0c0-.2.2-.3.4-.2h0c.2,0,.3.2.2.4h0c0,.2-.2.3-.3.3h0s0,0,0,0ZM73.9,393.1c-.2,0-.3-.3-.2-.4h0c0-.2.3-.3.4-.2h0c.2,0,.3.3.2.4h0c0,.1-.2.2-.3.2h0s0,0-.1,0ZM71.9,392.4h0c-.2,0-.3-.3-.2-.5h0c0-.2.3-.3.5-.2h0c.2,0,.3.3.2.4h0c0,.1-.2.2-.3.2h0s0,0-.1,0ZM69.9,391.6c-.2,0-.3-.3-.2-.5h0c0-.2.3-.3.5-.2h0c.2,0,.3.3.2.5h0c0,.1-.2.2-.3.2h0s0,0-.1,0ZM68,390.8c-.2,0-.2-.3-.2-.5h0c0-.2.3-.2.5-.2h0c.2,0,.2.3.2.5h0c0,.1-.2.2-.3.2h0s-.1,0-.2,0ZM66.1,389.8c-.2,0-.2-.3-.1-.5h0c0-.2.3-.2.5-.1h0c.2,0,.2.3.1.5h0c0,.1-.2.2-.3.2h0c0,0-.1,0-.2,0ZM64.2,388.8c-.2,0-.2-.3-.1-.5h0c0-.2.3-.2.5-.1h0c.2,0,.2.3.1.5h0c0,.1-.2.2-.3.2h0c0,0-.1,0-.2,0ZM62.4,387.7h0c-.2-.1-.2-.3-.1-.5h0c.1-.2.3-.2.5-.1h0c.2.1.2.3.1.5h0c0,.1-.2.2-.3.2h0c0,0-.1,0-.2,0ZM60.7,386.5c-.2-.1-.2-.3,0-.5h0c.1-.2.3-.2.5,0h0c.2.1.2.3,0,.5h0c0,0-.2.1-.3.1h0c0,0-.1,0-.2,0ZM59,385.3c-.2-.1-.2-.3,0-.5h0c.1-.2.3-.2.5,0h0c.2.1.2.3,0,.5h0c0,0-.2.1-.3.1h0c0,0-.2,0-.2,0ZM57.3,383.9h0c-.1-.1-.2-.3,0-.5h0c.1-.1.3-.2.5,0h0c.1.1.2.3,0,.5h0c0,0-.2.1-.3.1h0c0,0-.2,0-.2,0ZM55.7,382.5c-.1-.1-.2-.4,0-.5h0c.1-.1.4-.2.5,0h0c.1.1.2.4,0,.5h0c0,0-.2.1-.3.1h0c0,0-.2,0-.2,0ZM54.2,381.1c-.1-.1-.1-.4,0-.5h0c.1-.1.4-.1.5,0h0c.1.1.1.4,0,.5h0c0,0-.2.1-.2.1h0c0,0-.2,0-.2-.1ZM52.7,379.5c-.1-.1-.1-.4,0-.5h0c.1-.1.4-.1.5,0h0c.1.1.1.4,0,.5h0c0,0-.2,0-.2,0h0c0,0-.2,0-.3-.1ZM51.3,377.9h0c-.1-.2-.1-.4,0-.5h0c.2-.1.4-.1.5,0h0c.1.1.1.4,0,.5h0c0,0-.1,0-.2,0h0c-.1,0-.2,0-.3-.1ZM50,376.3c-.1-.2,0-.4,0-.5h0c.2-.1.4,0,.5,0h0c.1.2,0,.4,0,.5h0c0,0-.1,0-.2,0h0c-.1,0-.2,0-.3-.1ZM48.7,374.6c-.1-.2,0-.4,0-.5h0c.2-.1.4,0,.5,0h0c.1.2,0,.4,0,.5h0c0,0-.1,0-.2,0h0c-.1,0-.2,0-.3-.2ZM47.6,372.8h0c-.1-.2,0-.4.1-.5h0c.2-.1.4,0,.5.1h0c.1.2,0,.4-.1.5h0c0,0-.1,0-.2,0h0c-.1,0-.2,0-.3-.2ZM46.5,371c0-.2,0-.4.1-.5h0c.2,0,.4,0,.5.1h0c0,.2,0,.4-.1.5h0c0,0-.1,0-.2,0h0c-.1,0-.2,0-.3-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-1dcdb0a8-3b20-4c1c-95c7-f47a7168dde0",
    d: "M132.2,322.2c0,.7-.6,1.3-1.3,1.3s-1.3-.6-1.3-1.3.6-1.3,1.3-1.3,1.3.6,1.3,1.3Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "uuid-1dcdb0a8-3b20-4c1c-95c7-f47a7168dde0",
    cx: 137.4,
    cy: 346.5,
    r: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-1dcdb0a8-3b20-4c1c-95c7-f47a7168dde0",
    d: "M89.8,395.1c0,.6-.5,1-1,1s-1-.5-1-1,.5-1,1-1,1,.5,1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-1dcdb0a8-3b20-4c1c-95c7-f47a7168dde0",
    d: "M307.4,298c0,.5.4,1,1,1s1-.4,1-1-.4-1-1-1-1,.4-1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-1dcdb0a8-3b20-4c1c-95c7-f47a7168dde0",
    d: "M349.8,322.6c-8.5-14.8-24.4-23.9-41.5-23.9v-1.4c17.5,0,33.9,9.4,42.7,24.6l-1.2.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-1dcdb0a8-3b20-4c1c-95c7-f47a7168dde0",
    d: "M350.6,370.9l-.3-.2c4.2-7.3,6.5-15.7,6.5-24.2s-2.2-16.9-6.5-24.2l.3-.2c4.3,7.4,6.5,15.8,6.5,24.4s-2.3,17-6.5,24.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-1dcdb0a8-3b20-4c1c-95c7-f47a7168dde0",
    d: "M308,395.1c0-.2.2-.4.4-.4h0c.2,0,.4.2.4.4h0c0,.2-.2.4-.4.4h0c-.2,0-.4-.2-.4-.4ZM306.2,395.4h0c-.2,0-.3-.2-.3-.4h0c0-.2.2-.3.4-.3h0c.2,0,.3.2.3.4h0c0,.2-.2.3-.3.3h0ZM304.1,395.3h0c-.2,0-.3-.2-.3-.4h0c0-.2.2-.3.4-.3h0c.2,0,.3.2.3.4h0c0,.2-.2.3-.3.3h0ZM302,395h0c-.2,0-.3-.2-.3-.4h0c0-.2.2-.3.4-.3h0c.2,0,.3.2.3.4h0c0,.2-.2.3-.4.3h0s0,0,0,0ZM299.9,394.7c-.2,0-.3-.2-.3-.4h0c0-.2.2-.3.4-.3h0c.2,0,.3.2.3.4h0c0,.2-.2.3-.3.3h0s0,0,0,0ZM297.8,394.3c-.2,0-.3-.2-.3-.4h0c0-.2.2-.3.4-.3h0c.2,0,.3.2.3.4h0c0,.2-.2.3-.3.3h0s0,0,0,0ZM295.8,393.8h0c-.2,0-.3-.2-.2-.4h0c0-.2.2-.3.4-.2h0c.2,0,.3.2.3.4h0c0,.2-.2.3-.3.3h0s0,0,0,0ZM293.7,393.2c-.2,0-.3-.3-.2-.4h0c0-.2.3-.3.4-.2h0c.2,0,.3.3.2.4h0c0,.1-.2.2-.3.2h0s0,0-.1,0ZM291.7,392.5h0c-.2,0-.3-.3-.2-.4h0c0-.2.3-.3.4-.2h0c.2,0,.3.3.2.4h0c0,.1-.2.2-.3.2h0s0,0-.1,0ZM289.7,391.8c-.2,0-.3-.3-.2-.5h0c0-.2.3-.3.5-.2h0c.2,0,.3.3.2.5h0c0,.1-.2.2-.3.2h0s0,0-.1,0ZM287.8,390.9c-.2,0-.3-.3-.2-.5h0c0-.2.3-.3.5-.2h0c.2,0,.3.3.2.5h0c0,.1-.2.2-.3.2h0s-.1,0-.1,0ZM285.9,390c-.2,0-.2-.3-.2-.5h0c0-.2.3-.2.5-.2h0c.2,0,.2.3.2.5h0c0,.1-.2.2-.3.2h0c0,0-.1,0-.2,0ZM284,389c-.2,0-.2-.3-.1-.5h0c0-.2.3-.2.5-.1h0c.2,0,.2.3.1.5h0c0,.1-.2.2-.3.2h0c0,0-.1,0-.2,0ZM282.2,387.9c-.2-.1-.2-.3-.1-.5h0c.1-.2.3-.2.5-.1h0c.2.1.2.3.1.5h0c0,.1-.2.2-.3.2h0c0,0-.1,0-.2,0ZM280.4,386.7c-.2-.1-.2-.3,0-.5h0c.1-.2.3-.2.5,0h0c.2.1.2.3,0,.5h0c0,0-.2.2-.3.2h0c0,0-.1,0-.2,0ZM278.7,385.5c-.2-.1-.2-.3,0-.5h0c.1-.2.3-.2.5,0h0c.2.1.2.3,0,.5h0c0,0-.2.1-.3.1h0c0,0-.1,0-.2,0ZM277.1,384.1c-.1-.1-.2-.3,0-.5h0c.1-.2.3-.2.5,0h0c.1.1.2.3,0,.5h0c0,0-.2.1-.3.1h0c0,0-.2,0-.2,0ZM275.5,382.7c-.1-.1-.2-.4,0-.5h0c.1-.1.4-.2.5,0h0c.1.1.2.4,0,.5h0c0,0-.2.1-.3.1h0c0,0-.2,0-.2,0ZM273.9,381.3h0c-.1-.1-.1-.4,0-.5h0c.1-.1.4-.1.5,0h0c.1.1.1.4,0,.5h0c0,0-.2.1-.2.1h0c0,0-.2,0-.2-.1ZM272.5,379.8c-.1-.1-.1-.4,0-.5h0c.1-.1.4-.1.5,0h0c.1.1.1.4,0,.5h0c0,0-.2,0-.2,0h0c0,0-.2,0-.3-.1ZM271.1,378.2c-.1-.1-.1-.4,0-.5h0c.1-.1.4-.1.5,0h0c.1.1.1.4,0,.5h0c0,0-.1,0-.2,0h0c-.1,0-.2,0-.3-.1ZM269.7,376.5h0c-.1-.2,0-.4,0-.5h0c.2-.1.4,0,.5,0h0c.1.2,0,.4,0,.5h0c0,0-.1,0-.2,0h0c-.1,0-.2,0-.3-.1ZM268.5,374.8c-.1-.2,0-.4,0-.5h0c.2-.1.4,0,.5,0h0c.1.2,0,.4,0,.5h0c0,0-.1,0-.2,0h0c-.1,0-.2,0-.3-.1ZM267.3,373.1c-.1-.2,0-.4.1-.5h0c.2-.1.4,0,.5.1h0c.1.2,0,.4-.1.5h0c0,0-.1,0-.2,0h0c-.1,0-.2,0-.3-.2ZM266.1,371.3c0-.2,0-.4.1-.5h0c.2,0,.4,0,.5.1h0c0,.2,0,.4-.1.5h0c0,0-.1,0-.2,0h0c-.1,0-.2,0-.3-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-1dcdb0a8-3b20-4c1c-95c7-f47a7168dde0",
    d: "M266.1,370.9c-4.3-7.4-6.5-15.8-6.5-24.4s2.3-17,6.5-24.4l.3.2c-4.2,7.3-6.5,15.7-6.5,24.2s2.2,16.9,6.5,24.2l-.3.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-1dcdb0a8-3b20-4c1c-95c7-f47a7168dde0",
    d: "M308.4,395.2v-.2c8.7,0,17.2-2.3,24.6-6.7,7.2-4.2,13.2-10.3,17.4-17.6h.2c-4.2,7.4-10.2,13.4-17.5,17.7-7.4,4.4-16,6.7-24.7,6.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-1dcdb0a8-3b20-4c1c-95c7-f47a7168dde0",
    d: "M265,322.2c0,.7.6,1.3,1.3,1.3s1.3-.6,1.3-1.3-.6-1.3-1.3-1.3-1.3.6-1.3,1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-1dcdb0a8-3b20-4c1c-95c7-f47a7168dde0",
    d: "M258.6,346.5c0,.6.5,1.2,1.2,1.2s1.2-.5,1.2-1.2-.5-1.2-1.2-1.2-1.2.5-1.2,1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-1dcdb0a8-3b20-4c1c-95c7-f47a7168dde0",
    d: "M307.3,395.1c0,.6.5,1,1,1s1-.5,1-1-.5-1-1-1-1,.5-1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-1dcdb0a8-3b20-4c1c-95c7-f47a7168dde0",
    d: "M350.4,326.2c-2.1,0-3.8-1.7-3.8-3.8s1.7-3.8,3.8-3.8,3.8,1.7,3.8,3.8-1.7,3.8-3.8,3.8ZM350.4,318.7c-2,0-3.7,1.6-3.7,3.7s1.6,3.7,3.7,3.7,3.7-1.6,3.7-3.7-1.6-3.7-3.7-3.7Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "uuid-1dcdb0a8-3b20-4c1c-95c7-f47a7168dde0",
    cx: 350.4,
    cy: 322.3,
    r: 1.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "uuid-1dcdb0a8-3b20-4c1c-95c7-f47a7168dde0",
    cx: 350.4,
    cy: 370.8,
    r: 1.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "uuid-1dcdb0a8-3b20-4c1c-95c7-f47a7168dde0",
    x: 172.6,
    y: 377.6,
    width: 87.1,
    height: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    className: "uuid-1dcdb0a8-3b20-4c1c-95c7-f47a7168dde0",
    x: 156.2,
    y: 377.2,
    width: 16.5,
    height: 1.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "uuid-1dcdb0a8-3b20-4c1c-95c7-f47a7168dde0",
    x: 137.2,
    y: 377.8,
    width: 18.9,
    height: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "uuid-1dcdb0a8-3b20-4c1c-95c7-f47a7168dde0",
    x: 137,
    y: 347.8,
    width: 0.7,
    height: 45
  }), /*#__PURE__*/React.createElement("circle", {
    className: "uuid-1dcdb0a8-3b20-4c1c-95c7-f47a7168dde0",
    cx: 137.3,
    cy: 392.9,
    r: 1
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "uuid-1dcdb0a8-3b20-4c1c-95c7-f47a7168dde0",
    points: "170.6 407.2 172.3 405.6 173.4 408.5 170.6 407.2"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "uuid-1dcdb0a8-3b20-4c1c-95c7-f47a7168dde0",
    cx: 137.4,
    cy: 377.9,
    r: 1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "uuid-1dcdb0a8-3b20-4c1c-95c7-f47a7168dde0",
    x: 259.6,
    y: 346.3,
    width: 0.4,
    height: 37.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-1dcdb0a8-3b20-4c1c-95c7-f47a7168dde0",
    d: "M260.4,378c0,.4-.3.7-.7.7s-.7-.3-.7-.7.3-.7.7-.7.7.3.7.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-1dcdb0a8-3b20-4c1c-95c7-f47a7168dde0",
    d: "M260.4,374.5c0,.4-.3.7-.7.7s-.7-.3-.7-.7.3-.7.7-.7.7.3.7.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-1dcdb0a8-3b20-4c1c-95c7-f47a7168dde0",
    d: "M259.8,491.5c-12.7,0-25.4-4.8-35.1-14.5l1-1c18.8,18.8,49.4,18.8,68.2,0l1,1c-9.7,9.7-22.4,14.5-35.1,14.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-1dcdb0a8-3b20-4c1c-95c7-f47a7168dde0",
    d: "M294.9,476c-.1-.1-.1-.4,0-.5h0c.1-.1.4-.1.5,0h0c.1.1.1.4,0,.5h0c0,0-.2.1-.3.1h0c0,0-.2,0-.2,0ZM296.3,474.4c-.1-.1-.2-.4,0-.5h0c.1-.1.3-.2.5,0h0c.1.1.2.3,0,.5h0c0,0-.2.1-.3.1h0c0,0-.2,0-.2,0ZM297.7,472.8c-.2-.1-.2-.3,0-.5h0c.1-.2.3-.2.5,0h0c.2.1.2.3,0,.5h0c0,0-.2.1-.3.1h0c0,0-.2,0-.2,0ZM299,471.2c-.2-.1-.2-.3,0-.5h0c.1-.2.3-.2.5,0h0c.2.1.2.3,0,.5h0c0,0-.2.1-.3.1h0c0,0-.1,0-.2,0ZM300.2,469.5c-.2-.1-.2-.3,0-.5h0c.1-.2.3-.2.5,0h0c.2.1.2.3,0,.5h0c0,.1-.2.2-.3.2h0c0,0-.1,0-.2,0ZM301.3,467.7c-.2-.1-.2-.3-.1-.5h0c.1-.2.3-.2.5-.1h0c.2.1.2.3.1.5h0c0,.1-.2.2-.3.2h0c0,0-.1,0-.2,0ZM302.4,465.9c-.2,0-.2-.3-.1-.5h0c0-.2.3-.2.5-.1h0c.2,0,.2.3.1.5h0c0,.1-.2.2-.3.2h0c0,0-.1,0-.2,0ZM303.4,464c-.2,0-.2-.3-.2-.5h0c0-.2.3-.2.5-.2h0c.2,0,.2.3.2.5h0c0,.1-.2.2-.3.2h0c0,0-.1,0-.2,0ZM304.3,462.1c-.2,0-.3-.3-.2-.5h0c0-.2.3-.3.5-.2h0c.2,0,.3.3.2.5h0c0,.1-.2.2-.3.2h0s0,0-.1,0ZM305.2,460.2c-.2,0-.3-.3-.2-.5h0c0-.2.3-.3.5-.2h0c.2,0,.3.3.2.5h0c0,.1-.2.2-.3.2h0s0,0-.1,0ZM305.9,458.2c-.2,0-.3-.3-.2-.4h0c0-.2.3-.3.4-.2h0c.2,0,.3.3.2.4h0c0,.1-.2.2-.3.2h0s0,0-.1,0ZM306.6,456.2c-.2,0-.3-.3-.2-.4h0c0-.2.3-.3.4-.2h0c.2,0,.3.3.2.4h0c0,.2-.2.2-.3.2h0s0,0,0,0ZM307.1,454.2c-.2,0-.3-.2-.3-.4h0c0-.2.2-.3.4-.3h0c.2,0,.3.2.3.4h0c0,.2-.2.3-.3.3h0s0,0,0,0ZM307.6,452.2c-.2,0-.3-.2-.3-.4h0c0-.2.2-.3.4-.3h0c.2,0,.3.2.3.4h0c0,.2-.2.3-.3.3h0s0,0,0,0ZM308,450.1c-.2,0-.3-.2-.3-.4h0c0-.2.2-.3.4-.3h0c.2,0,.3.2.3.4h0c0,.2-.2.3-.3.3h0s0,0,0,0ZM308.3,448c-.2,0-.3-.2-.3-.4h0c0-.2.2-.3.4-.3h0c.2,0,.3.2.3.4h0c0,.2-.2.3-.3.3h0s0,0,0,0ZM308.5,445.9c-.2,0-.3-.2-.3-.4h0c0-.2.2-.3.4-.3h0c.2,0,.3.2.3.4h0c0,.2-.2.3-.4.3h0s0,0,0,0ZM308.7,443.8c-.2,0-.3-.2-.3-.4h0c0-.2.2-.3.4-.3h0c.2,0,.3.2.3.4h0c0,.2-.2.3-.4.3h0ZM308.3,441.4c0-.2.2-.4.3-.4h0c.2,0,.4.2.4.3h0c0,.2-.2.4-.3.4h0c-.2,0-.4-.2-.4-.3ZM308.3,439.3h0c0-.2.1-.4.3-.4h0c.2,0,.4.1.4.3h0c0,.2-.1.4-.3.4h0c-.2,0-.3-.1-.3-.3ZM308.1,437.2h0c0-.2.1-.4.3-.4h0c.2,0,.4.1.4.3h0c0,.2-.1.4-.3.4h0s0,0,0,0h0c-.2,0-.3-.1-.3-.3ZM307.9,435.1c0-.2.1-.4.3-.4h0c.2,0,.4.1.4.3h0c0,.2-.1.4-.3.4h0s0,0,0,0h0c-.2,0-.3-.1-.3-.3ZM307.5,433h0c0-.2,0-.4.3-.4h0c.2,0,.4,0,.4.3h0c0,.2,0,.4-.3.4h0s0,0,0,0h0c-.2,0-.3-.1-.3-.3ZM307.1,431h0c0-.2,0-.4.3-.4h0c.2,0,.4,0,.4.3h0c0,.2,0,.4-.3.4h0s0,0,0,0h0c-.2,0-.3-.1-.3-.3ZM306.6,429h0c0-.2,0-.4.2-.4h0c.2,0,.4,0,.4.2h0c0,.2,0,.4-.2.4h0s0,0,0,0h0c-.2,0-.3-.1-.3-.3ZM306,427h0c0-.2,0-.4.2-.4h0c.2,0,.4,0,.4.2h0c0,.2,0,.4-.2.4h0s0,0-.1,0h0c-.1,0-.3,0-.3-.2ZM305.3,425h0c0-.2,0-.4.2-.5h0c.2,0,.4,0,.5.2h0c0,.2,0,.4-.2.5h0s0,0-.1,0h0c-.1,0-.3,0-.3-.2ZM304.6,423c0-.2,0-.4.2-.5h0c.2,0,.4,0,.5.2h0c0,.2,0,.4-.2.5h0s0,0-.1,0h0c-.1,0-.3,0-.3-.2ZM303.7,421.1c0-.2,0-.4.2-.5h0c.2,0,.4,0,.5.2h0c0,.2,0,.4-.2.5h0s0,0-.2,0h0c-.1,0-.3,0-.3-.2ZM302.8,419.3c0-.2,0-.4.1-.5h0c.2,0,.4,0,.5.1h0c0,.2,0,.4-.1.5h0c0,0-.1,0-.2,0h0c-.1,0-.2,0-.3-.2ZM301.8,417.4c0-.2,0-.4.1-.5h0c.2,0,.4,0,.5.1h0c0,.2,0,.4-.1.5h0c0,0-.1,0-.2,0h0c-.1,0-.2,0-.3-.2ZM300.7,415.7h0c-.1-.2,0-.4.1-.5h0c.2-.1.4,0,.5.1h0c.1.2,0,.4-.1.5h0c0,0-.1,0-.2,0h0c-.1,0-.2,0-.3-.2ZM299.5,413.9c-.1-.2,0-.4,0-.5h0c.2-.1.4,0,.5,0h0c.1.2,0,.4,0,.5h0c0,0-.1,0-.2,0h0c-.1,0-.2,0-.3-.2ZM298.3,412.2h0c-.1-.2,0-.4,0-.5h0c.2-.1.4,0,.5,0h0c.1.2,0,.4,0,.5h0c0,0-.1,0-.2,0h0c-.1,0-.2,0-.3-.1ZM296.9,410.6c-.1-.1-.1-.4,0-.5h0c.1-.1.4-.1.5,0h0c.1.1.1.4,0,.5h0c0,0-.1,0-.2,0h0c0,0-.2,0-.3-.1ZM295.6,409c-.1-.1-.1-.4,0-.5h0c.1-.1.4-.1.5,0h0c.1.1.1.4,0,.5h0c0,0-.2,0-.2,0h0c0,0-.2,0-.3-.1ZM294.1,407.5h0c-.1-.1-.1-.4,0-.5h0c.1-.1.4-.1.5,0h0c.1.1.1.4,0,.5h0c0,0-.2.1-.2.1h0c0,0-.2,0-.2-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-1dcdb0a8-3b20-4c1c-95c7-f47a7168dde0",
    d: "M293.9,407.8c-18.8-18.8-49.4-18.8-68.2,0l-1-1c19.4-19.4,50.8-19.4,70.2,0l-1,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-1dcdb0a8-3b20-4c1c-95c7-f47a7168dde0",
    d: "M225,476.6c-19.1-19.1-19.1-50.3,0-69.5l.2.2c-19,19-19,49.9,0,69l-.2.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "uuid-1dcdb0a8-3b20-4c1c-95c7-f47a7168dde0",
    points: "258.6 383.9 261 383.9 259.8 386.7 258.6 383.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "uuid-1dcdb0a8-3b20-4c1c-95c7-f47a7168dde0",
    points: "258.6 387.2 261 387.2 259.8 390.1 258.6 387.2"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "uuid-1dcdb0a8-3b20-4c1c-95c7-f47a7168dde0",
    cx: 259.8,
    cy: 392.2,
    r: 1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "uuid-1dcdb0a8-3b20-4c1c-95c7-f47a7168dde0",
    x: 228.9,
    y: 373.7,
    width: 0.2,
    height: 4.8,
    transform: "translate(-198.8 272.1) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-1dcdb0a8-3b20-4c1c-95c7-f47a7168dde0",
    d: "M226.6,374.4c0,0,0-.2.2-.2h0c0,0,.2,0,.2.2h0c0,0,0,.2-.2.2h0c0,0-.2,0-.2-.2ZM225.6,374.4c0,0,0-.2.2-.2h0c0,0,.2,0,.2.2h0c0,0,0,.2-.2.2h0c0,0-.2,0-.2-.2ZM224.5,374.4c0,0,0-.2.2-.2h0c0,0,.2,0,.2.2h0c0,0,0,.2-.2.2h0c0,0-.2,0-.2-.2ZM223.5,374.4c0,0,0-.2.2-.2h0c0,0,.2,0,.2.2h0c0,0,0,.2-.2.2h0c0,0-.2,0-.2-.2ZM222.4,374.4c0,0,0-.2.2-.2h0c0,0,.2,0,.2.2h0c0,0,0,.2-.2.2h0c0,0-.2,0-.2-.2ZM221.4,374.4c0,0,0-.2.2-.2h0c0,0,.2,0,.2.2h0c0,0,0,.2-.2.2h0c0,0-.2,0-.2-.2ZM220.3,374.4c0,0,0-.2.2-.2h0c0,0,.2,0,.2.2h0c0,0,0,.2-.2.2h0c0,0-.2,0-.2-.2ZM219.3,374.4c0,0,0-.2.2-.2h0c0,0,.2,0,.2.2h0c0,0,0,.2-.2.2h0c0,0-.2,0-.2-.2ZM218.2,374.4c0,0,0-.2.2-.2h0c0,0,.2,0,.2.2h0c0,0,0,.2-.2.2h0c0,0-.2,0-.2-.2ZM217.1,374.4c0,0,0-.2.2-.2h0c0,0,.2,0,.2.2h0c0,0,0,.2-.2.2h0c0,0-.2,0-.2-.2ZM216.1,374.4c0,0,0-.2.2-.2h0c0,0,.2,0,.2.2h0c0,0,0,.2-.2.2h0c0,0-.2,0-.2-.2Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "uuid-1dcdb0a8-3b20-4c1c-95c7-f47a7168dde0",
    x: 207,
    y: 378.1,
    width: 10.8,
    height: 0.2,
    transform: "translate(-205.2 261) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "uuid-1dcdb0a8-3b20-4c1c-95c7-f47a7168dde0",
    x: 198.2,
    y: 381.8,
    width: 10.4,
    height: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-1dcdb0a8-3b20-4c1c-95c7-f47a7168dde0",
    d: "M216.8,374.4c0,.3-.2.5-.5.5s-.5-.2-.5-.5.2-.5.5-.5.5.2.5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-1dcdb0a8-3b20-4c1c-95c7-f47a7168dde0",
    d: "M227.8,374.4c0,.3-.2.5-.5.5s-.5-.2-.5-.5.2-.5.5-.5.5.2.5.5Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "uuid-1dcdb0a8-3b20-4c1c-95c7-f47a7168dde0",
    cx: 198.3,
    cy: 382,
    r: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-28380f90-cb0a-4c2c-a4d5-efa0ff11e1e8",
    d: "M226.8,345.1v-3.8h-55.4v3.8h0c0,.8,12.4,1.4,27.7,1.4s27.7-.6,27.7-1.4h0Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "uuid-e12a521e-a6bf-4f2d-b75a-db1725d6a1e7",
    cx: 199.1,
    cy: 341.3,
    rx: 27.7,
    ry: 1.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-4bc95293-8cd5-4577-8443-df765a30e13d",
    d: "M174.6,332.9h0v8.4s0,0,0,0c0,.4,11,.8,24.5.8s24.5-.3,24.5-.8v-8.4h-48.9Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "uuid-fd5f24bc-eaeb-449a-beb4-7a18ffbf407d",
    cx: 199.1,
    cy: 332.9,
    rx: 24.5,
    ry: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-eabdd1ac-7543-476f-a9a1-efc11eeff44a",
    d: "M199.1,335.6c-3.5,0-6.7,0-9.5,0v4.6c.6,0,1.1,0,1.7,0,2.4,0,5,0,7.8,0s5.4,0,7.8,0c.6,0,1.2,0,1.7,0v-4.6c-2.8,0-6.1,0-9.5,0Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "uuid-ff523dc7-75db-4957-a022-a7a5c3a78956",
    cx: 190.5,
    cy: 336.3,
    rx: 0.3,
    ry: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-6de3603d-e94a-470c-ad10-dd53bef6d82d",
    d: "M190.7,339.4c0,.1-.1.3-.3.3s-.3-.1-.3-.3.1-.3.3-.3c.2,0,.3.1.3.3Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "uuid-c9bc928b-69dc-453d-bb84-6b430ab8dcc5",
    cx: 207.7,
    cy: 336.3,
    rx: 0.3,
    ry: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-9a16e04f-a073-4700-a3ef-44e84614b0dd",
    d: "M207.9,339.4c0,.1-.1.3-.3.3s-.3-.1-.3-.3.1-.3.3-.3c.2,0,.3.1.3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-2c3d25ec-04fa-4bff-9df4-c62b3b45698f",
    d: "M178.8,275.4v57.7h40.5v-57.7h-40.5ZM218.8,332.5h-39.4v-56.5h39.4v56.5Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "uuid-97728ca5-f369-4d43-abb3-ae09594750e3",
    points: "179.4 332.5 218.8 332.5 218.8 275.9 179.4 275.9 179.4 332.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "uuid-c8572e57-ce03-4734-a329-bb8682074307",
    points: "182 329.9 182 278.5 216.2 278.5 216.2 329.9 182 329.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "uuid-6f6e0027-f60c-41b0-884c-328751b12d41",
    points: "293.3 383.1 290.5 381.1 287.6 383.1 287.6 375.2 293.3 375.2 293.3 383.1"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "uuid-183f9d87-d256-4c1a-bf2f-92b90daf91d2",
    x: 287.6,
    y: 375.2,
    width: 5.7,
    height: 4.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "uuid-61e72ca5-1928-4024-912a-46feb0769b5d",
    x: 279.2,
    y: 310.6,
    width: 45.7,
    height: 67.6,
    rx: 2.9,
    ry: 2.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-755e9d62-6e6a-4665-8dbe-5ccb9f56133f",
    d: "M321.8,376.9h-38.4c-1.6,0-2.9-1.3-2.9-2.9v-60.3c0-.6.2-1.2.6-1.7-.7.5-1.2,1.4-1.2,2.3v60.3c0,1.6,1.3,2.9,2.9,2.9h38.4c1,0,1.8-.5,2.3-1.2-.5.3-1.1.6-1.7.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-7ee8549f-7565-47fd-9e28-eccbdd30cb03",
    d: "M321.6,311.4h-38.6c-1.1,0-2.1.7-2.5,1.6.4-.2.8-.3,1.2-.3h38.6c1.6,0,2.8,1.3,2.8,2.8v59.8c0,.4-.1.8-.3,1.2.9-.5,1.6-1.4,1.6-2.5v-59.8c0-1.6-1.3-2.8-2.8-2.8Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "uuid-caab3569-67dd-48f8-93fa-229de7efa791",
    x: 313.7,
    y: 310.6,
    width: 2.6,
    height: 67.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 313.7,
    y: 310.6,
    width: 0.1,
    height: 67.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 314,
    y: 310.6,
    width: 0.1,
    height: 67.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 314.3,
    y: 310.6,
    width: 0.1,
    height: 67.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 314.5,
    y: 310.6,
    width: 0.1,
    height: 67.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 314.8,
    y: 310.6,
    width: 0.1,
    height: 67.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315,
    y: 310.6,
    width: 0.1,
    height: 67.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315.3,
    y: 310.6,
    width: 0.1,
    height: 67.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315.5,
    y: 310.6,
    width: 0.1,
    height: 67.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315.8,
    y: 310.6,
    width: 0.1,
    height: 67.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.1,
    y: 310.6,
    width: 0.1,
    height: 67.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.1,336.5c-.5.4-1,.6-1.7.5-1.4-.2-.9-1.8.6-1.2.3,0,.8.4,1,.5,1-1,1.5-2.8,2.6-4-.7-.4-1.5-.6-2.3-.4-1.9.4-2.4,2.1-1.4,2.4.8.3,1.2-.5,1.2-.7,0,0,.2,0,.1,0,0,.7-.8,1-1.4.8-1.2-.4-1.1-2.4,1.6-2.8.8-.1,1.7,0,2.4.4.3-.4.7-.7.9-.6,0,0,0,0,0,0-.2,0-.5.5-.6.7.9.6,1.5,1.6,1.4,2.9-.2,2.2-3,2.1-4.4,1.4ZM295.9,335.9c-1-.3-1.1.8-.3.9.5,0,.9-.1,1.3-.4-.3-.2-.6-.3-1-.5ZM300,332.4c-.8,1.2-1.7,2.9-2.4,3.7,0,0-.2.2-.3.2,1.3.8,3.6.5,3.8-1.2.1-1.1-.4-2.1-1.1-2.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.1,336.5c.1,0,.2,0,.3-.1.2-.2.4-.6.6-1,0-.1.1,0,0,0-.2.4-.6,1.2-1.1,1.2s-.5-.5-.4-.9l.4-1.1c0-.1,0-.2,0-.3h.4c.2,0,.2,0,.1.2l-.5,1.3s0,.1,0,.2c0,.2,0,.4.1.4ZM302.6,334.1c-.2,0-.3-.1-.2-.3,0-.2.2-.3.3-.3s.3.1.2.3c0,.2-.2.3-.3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.5,336.7c-.2,0-.5-.2-.3-.9-.1.2-.3.4-.5.6-.8.7-1.3-.4-.3-1.7.4-.5,1.2-.7,1.6-.3,0,.1,0,.2,0,.2,0-.3-.3-.3-.6-.2-.3.2-.7.6-.9,1,0,0-.2.4-.3.7,0,.5.3.4.6,0,.2-.3.4-.6.6-.9.1-.3.2-.4.5-.4,0,0,.2,0,.3,0-.1.1-.5.9-.6,1.3,0,.3,0,.4,0,.4.3,0,.7-.8.9-1.1,0-.1.2,0,0,0-.2.4-.6,1.2-1,1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.3,336.7c-.2,0-.6-.1-.4-.9.1-.3.3-.6.4-.8,0-.2-.1-.3-.5-.3v.2c-.2.4-.6,1.2-.9,1.5,0,0,0,0,0,0,.5-.7.9-1.7,1-2.5,0-.4.5-.2.4.2,0,.2-.3.4-.4.5.3,0,.6,0,.9,0,0,0,0,.4-.1.5-.1.2-.8,1.4-.4,1.5.3,0,.7-.8.8-1.1,0-.1.1,0,0,0-.2.4-.5,1.1-1,1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.3,337c-.4.8-1.1,1.8-2.1,1.8s-.7-.4-.5-.8c.1-.2.4-.4.6-.6.5-.2,1.1-.3,1.6-.5.3-.4.5-1.2.6-1.5-.2.4-.7,1.2-1.2,1.2s-.4,0-.4-.3c0-.3.1-.5.2-.8,0,0-.1,0,0-.1v-.2c.3-.3.4-.5.5-.7,0-.1.1-.1.3-.1h.4c0,0-.2.1-.2.2-.2.4-.4.8-.6,1.2-.3.7,0,1,.4.5.4-.4.8-1.2,1.1-1.8,0-.1.1-.1.3-.1h.4c-.3.2-.4.4-.5.9-.2.5-.3,1-.5,1.5.3,0,.7-.3,1-.7.2-.3.4-.6.4-.7,0-.1.2,0,0,0-.5.9-.6,1.2-1.6,1.6ZM306.4,337.6c-.7.3-.9,1.1-.4,1.1s1.3-.8,1.6-1.3v-.3c-.3.1-.9.3-1.3.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294,335.2c0,.2-.1.3-.3.3s-.3-.1-.3-.3.1-.3.3-.3.3.1.3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.2,335.2c0,.2-.1.3-.3.3s-.3-.1-.3-.3.1-.3.3-.3.3.1.3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-48229acf-073d-4e34-be85-8af05d5d9ae6",
    d: "M66,346.1c-.2,0-.4-.2-.4-.4s.2-.4.4-.4.4.2.4.4-.2.4-.4.4M65.8,335.1c-.2-1.5-.5-2.9-.7-4.4-.5-2.9-1-6-1.4-8.9-.3-2.3-.8-6.7.5-9,.7-1.3,1.8-2,2.8-2s1.8.7,2.3,2c1.7,4.1-.7,11.3-1.6,14,0,.2-1.3,3.5-1.9,8.4M67,309.6c-1.5,0-3,1-3.9,2.6-1.5,2.7-.9,7.1-.6,9.7.4,3,.9,6,1.4,9,.5,2.9,1,6,1.4,9h-.9v4.9h.3v1.4h-11.6v17.6h1s23.5,0,23.5,0h0s.1,0,.1,0h.9v-17.6h-11.3v-1.4h.3v-4.9h-.9c.2-7.2,2.2-12.9,2.3-12.9,1.6-4.8,3.2-10.9,1.6-14.8-.7-1.7-1.9-2.7-3.4-2.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-61e72ca5-1928-4024-912a-46feb0769b5d",
    d: "M65.5,339.9h-1.1v-.7c-.4-3.1-.9-6.2-1.5-9.2-.5-2.9-1-6-1.4-9-.3-2.6-.9-7.1.6-9.7.9-1.6,2.4-2.6,3.9-2.6s2.7,1,3.4,2.7c1.6,4,0,10-1.6,14.8,0,0-2.2,6.1-2.3,13.8ZM65.9,309.7c-1.1,0-2.2.8-2.8,2-1.3,2.4-.8,6.7-.5,9,.4,3,.9,6,1.4,8.9.3,1.4.5,2.9.7,4.4.7-4.9,1.8-8.2,1.9-8.4.9-2.7,3.3-9.9,1.6-14-.5-1.3-1.4-2-2.3-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-61e72ca5-1928-4024-912a-46feb0769b5d",
    d: "M76.5,345.3h-23.5c-.5,0-1,.4-1,1v15.6c0,.5.4,1,1,1h23.5c.5,0,1-.4,1-1v-15.6c0-.5-.4-1-1-1ZM67.1,347h-4.6c-.2,0-.4-.2-.4-.4s.2-.4.4-.4h4.6c.2,0,.4.2.4.4,0,.2-.2.4-.4.4Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "uuid-0a1bbc5a-b788-4ce2-8500-fb677d294b64",
    x: 53.7,
    y: 348.3,
    width: 22.2,
    height: 13.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-7cde0a89-1d0a-4d4f-97d5-88227c5debc1",
    d: "M63.7,343.9v3.1h2.5v-3.1h-2.5ZM64.9,345.1c-.2,0-.4-.2-.4-.4s.2-.4.4-.4.4.2.4.4c0,.2-.2.4-.4.4Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "uuid-3f7b1093-941b-4132-90b2-fa05339cb1e1",
    x: 63.4,
    y: 339,
    width: 3.1,
    height: 4.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "uuid-3f7b1093-941b-4132-90b2-fa05339cb1e1",
    x: 55.2,
    y: 358.5,
    width: 12.2,
    height: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "uuid-3f7b1093-941b-4132-90b2-fa05339cb1e1",
    x: 68.5,
    y: 358.5,
    width: 5.8,
    height: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "uuid-3f7b1093-941b-4132-90b2-fa05339cb1e1",
    x: 55.2,
    y: 359.5,
    width: 4.7,
    height: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "uuid-3f7b1093-941b-4132-90b2-fa05339cb1e1",
    x: 60.6,
    y: 359.5,
    width: 4.6,
    height: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "uuid-3f7b1093-941b-4132-90b2-fa05339cb1e1",
    x: 65.7,
    y: 359.5,
    width: 8.6,
    height: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "uuid-3f7b1093-941b-4132-90b2-fa05339cb1e1",
    x: 67.9,
    y: 349.8,
    width: 6.4,
    height: 7.8
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "uuid-28dfd135-468a-4929-9568-7d7fb77366dd",
    points: "56.9 357.2 56.9 357.2 56.9 356.9 56.8 356.9 56.8 356.9 56.8 356.9 56.8 357.3 56.8 357.3 56.9 357.3 56.9 357.3 56.9 357.2 56.9 357.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-28dfd135-468a-4929-9568-7d7fb77366dd",
    d: "M57.1,356.9c0,0,0,0,0,0v.2c0,0,0,0,0,0s0,0,0,0v-.2c0,0,0,0,0,0ZM57.1,357.2h0s0,0,0,0v-.2h0s0,0,0,0v.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-28dfd135-468a-4929-9568-7d7fb77366dd",
    d: "M57.3,356.9h0v.4h0s0,0,0,0h0v-.2h0v.2h0s0,0,0,0h0c0-.1,0-.2,0-.2h0c0-.2,0-.2,0-.2ZM57.3,357h0s0,0,0,0h0c0-.1,0-.1,0-.1h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "uuid-28dfd135-468a-4929-9568-7d7fb77366dd",
    points: "57.6 356.9 57.5 356.9 57.5 356.9 57.5 357.3 57.5 357.3 57.6 357.3 57.6 357.3 57.6 357.2 57.6 357.2 57.5 357.2 57.5 357.1 57.6 357.1 57.6 357.1 57.6 357.1 57.6 357.1 57.5 357.1 57.5 356.9 57.6 356.9 57.6 356.9 57.6 356.9 57.6 356.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-28dfd135-468a-4929-9568-7d7fb77366dd",
    d: "M57.9,356.9h0s0,0,0,0c0,0,0,0,0,0v.3h0s0,0,0,0h0v-.3h0s0,0,0,0v.3h0s0,0,0,0h0v-.3h0s0,0,0,0v.3h0s0,0,0,0h0v-.3c0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "uuid-28dfd135-468a-4929-9568-7d7fb77366dd",
    points: "58.2 356.9 58.2 356.9 58.2 356.9 58.2 357.3 58.2 357.3 58.2 357.3 58.2 357.3 58.2 356.9 58.2 356.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-28dfd135-468a-4929-9568-7d7fb77366dd",
    d: "M58.4,356.9h0v.2h0v.2h0s0,0,0,0h0v-.2h0c0,0,0,0,0,0h0c0,0,0-.1,0-.1ZM58.4,357h0s0,0,0,0h0c0-.1,0-.1,0-.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-28dfd135-468a-4929-9568-7d7fb77366dd",
    d: "M58.6,356.9c0,0,0,0,0,0h0c0,0,.1.2.1.2h0s0,0,0,0h0c0,0,0,0,0,0h0c0,0,0,.1,0,.1s0,0,0,0h0c0,0-.1-.2-.1-.2h0s0,0,0,0h0c0,0,0,0,0,0h0c0,0,0-.1,0-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-28dfd135-468a-4929-9568-7d7fb77366dd",
    d: "M58.9,356.9h0v.3h0s0,0,0,0v-.3h0s0,0,0,0h0v.3c0,0,0,0,0,0s0,0,0,0v-.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-28dfd135-468a-4929-9568-7d7fb77366dd",
    d: "M59.2,356.9h0s0,0,0,0c0,0,0,0,0,0v.3h0s0,0,0,0h0v-.3h0s0,0,0,0v.3h0s0,0,0,0h0v-.3h0s0,0,0,0v.3h0s0,0,0,0h0v-.3c0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "uuid-28dfd135-468a-4929-9568-7d7fb77366dd",
    points: "56.5 355.7 56.2 355.7 56.2 356.7 56.7 356.7 56.7 356.5 56.5 356.5 56.5 355.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-28dfd135-468a-4929-9568-7d7fb77366dd",
    d: "M57.4,355.8s0,0-.1,0c0,0-.1,0-.2,0s-.1,0-.2,0c0,0,0,0-.1,0,0,0,0,0,0,.1,0,0,0,.1,0,.3s0,.2,0,.3c0,0,0,0,0,.1,0,0,0,0,.1,0,0,0,.1,0,.2,0s.1,0,.2,0c0,0,0,0,.1,0,0,0,0,0,0-.1,0,0,0-.1,0-.3s0-.2,0-.3c0,0,0,0,0-.1ZM57.2,356.3c0,.1,0,.2,0,.2h0s0,0,0,0c0,0,0,0,0-.2v-.2c0-.1,0-.2,0-.2h0s0,0,0,0c0,0,0,0,0,.2v.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-28dfd135-468a-4929-9568-7d7fb77366dd",
    d: "M58.2,356.4h0c0-.1,0-.2-.1-.2h0c0-.1,0-.2,0-.2s0,0,0-.1h0c0,0,0-.1,0-.1,0,0-.1,0-.2,0h-.3v1h.2v-.4h.1c0,0,0,0,0,.2h0s0,.1,0,.1h0c0,0,0,.1,0,.1h.3s0,0,0-.2h0ZM57.9,356.1s0,0-.1,0h0s0,0,0,0v-.2h0s0,0,0,0c0,0,0,0,.1,0h0c0,.1,0,.2,0,.2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "uuid-28dfd135-468a-4929-9568-7d7fb77366dd",
    points: "58.9 355.9 58.9 355.7 58.4 355.7 58.4 356.7 58.9 356.7 58.9 356.5 58.6 356.5 58.6 356.3 58.9 356.3 58.9 356.1 58.6 356.1 58.6 355.9 58.9 355.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-28dfd135-468a-4929-9568-7d7fb77366dd",
    d: "M59.5,356.1s0,0,0,0c0,0,0,.1,0,.1,0,0,0-.1,0-.2,0,0,0,0,0,0v-.4h-.4v1h.2v-.8s.1.8.1.8h.2l.2-.8v.8s.2,0,.2,0v-1h-.3v.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-28dfd135-468a-4929-9568-7d7fb77366dd",
    d: "M58.1,349.7c-1.6,0-2.9,1.3-2.9,2.9s1.3,2.9,2.9,2.9,2.9-1.3,2.9-2.9c0-1.6-1.3-2.9-2.9-2.9ZM60.7,352.4c-.2-.2-.7-.7-1.4-.7s-.4,0-.6.1c0-.2.1-.4.1-.6,0-.7-.5-1.2-.7-1.4,1.3,0,2.4,1.2,2.5,2.5ZM60.6,352.6c-.2.2-.6.6-1.2.6s-.6-.1-.9-.4c0-.1-.2-.2-.2-.3.1-.1.2-.2.3-.3.3-.2.5-.3.8-.3.6,0,1.1.4,1.2.6ZM58.1,350.1c.2.2.6.6.6,1.2,0,.3-.1.6-.3.8-.1,0-.2.2-.3.3,0,0-.1-.1-.3-.2-.2-.3-.4-.6-.4-.9,0-.6.4-1.1.6-1.2ZM57.9,352.6s-.1.1-.2.2c-.2.2-.6.4-1,.4s-.8-.2-1.1-.6c.4-.4.7-.6,1.1-.6s.7.2,1,.4c0,0,.1.2.2.2ZM57.9,349.9c-.2.2-.7.7-.7,1.4,0,.2,0,.4.1.6-.2,0-.4-.2-.7-.2-.5,0-.9.2-1.3.7,0-1.3,1.2-2.4,2.5-2.5ZM55.4,352.7c.4.4.8.7,1.3.7s.5,0,.7-.2c-.1.2-.2.4-.2.7,0,.5.2.9.7,1.3-1.3,0-2.4-1.1-2.5-2.5ZM58.1,355.1c-.4-.4-.6-.7-.6-1.1,0-.4.2-.8.4-1,0,0,.1-.1.2-.2,0,0,.2.2.2.2.2.2.4.6.4,1,0,.4-.2.8-.6,1.1ZM58.2,355.2c.4-.4.7-.8.7-1.3,0-.2,0-.5-.2-.7.2,0,.4.1.6.1.7,0,1.2-.5,1.4-.7,0,1.3-1.1,2.4-2.5,2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-28dfd135-468a-4929-9568-7d7fb77366dd",
    d: "M56.7,351.5c.2,0,.4-.2.4-.4s-.2-.4-.4-.4-.4.2-.4.4.2.4.4.4ZM56.7,351c0,0,.2,0,.2.2s0,.2-.2.2-.2,0-.2-.2,0-.2.2-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-28dfd135-468a-4929-9568-7d7fb77366dd",
    d: "M56.7,353.7c-.2,0-.4.2-.4.4s.2.4.4.4.4-.2.4-.4-.2-.4-.4-.4ZM56.7,354.2c0,0-.2,0-.2-.2s0-.2.2-.2.2,0,.2.2c0,0,0,.2-.2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-28dfd135-468a-4929-9568-7d7fb77366dd",
    d: "M59.5,351.5c.2,0,.4-.2.4-.4s-.2-.4-.4-.4-.4.2-.4.4.2.4.4.4ZM59.5,351c0,0,.2,0,.2.2s0,.2-.2.2-.2,0-.2-.2c0,0,0-.2.2-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-28dfd135-468a-4929-9568-7d7fb77366dd",
    d: "M59.5,353.7c-.2,0-.4.2-.4.4s.2.4.4.4.4-.2.4-.4-.2-.4-.4-.4ZM59.5,354.2c0,0-.2,0-.2-.2s0-.2.2-.2.2,0,.2.2c0,0,0,.2-.2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-61e72ca5-1928-4024-912a-46feb0769b5d",
    d: "M70.9,375.2v7.6c0,2.3.8,2,3.2,2h21v-11.7h-21c-2.3,0-3.2-.3-3.2,2"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "uuid-b30c3822-e79e-4032-b619-ccc41c017703",
    points: "100.8 374.8 100.8 383.1 95.1 383.1 95.1 374.8 100.8 374.8"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "uuid-75c5a858-763e-4c1a-8654-9cf21e8b25e3",
    points: "95.1 383.1 95.1 383.1 100.8 383.1 100.8 379 95.9 379 95.9 381 96.9 381 96.9 380.5 96.9 380 98.5 380 98.5 381 100.8 381 100.8 383.1 95.1 383.1"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "uuid-0399e8d7-ee57-43b0-aad9-444b40b9d011",
    points: "95.1 383.1 95.1 383.1 100.8 383.1 100.8 381 98.5 381 98.5 381.5 96.9 381.5 96.9 381 95.9 381 95.9 383.1 95.1 383.1"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "uuid-650b9594-cc22-499e-a5fd-acbf290376d0",
    points: "98.5 380 98.5 381.5 96.9 381.5 96.9 380 98.5 380"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "uuid-c3d1e125-47da-4ffc-ae60-24f5a9ade738",
    points: "96.9 380.5 96.9 381 96.9 381.5 98.5 381.5 98.5 380.5 96.9 380.5"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "uuid-650b9594-cc22-499e-a5fd-acbf290376d0",
    points: "98.5 376.4 98.5 378 96.9 378 96.9 376.4 98.5 376.4"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "uuid-c3d1e125-47da-4ffc-ae60-24f5a9ade738",
    points: "96.9 377 96.9 378 98.5 378 98.5 377 96.9 377"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "uuid-73531d05-360a-4fd3-891d-b15041dd593e",
    points: "95.1 374.8 95.1 379 95.9 379 95.9 374.8 95.1 374.8"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "uuid-623bd507-96b6-4874-bc7a-c17c7f071085",
    points: "95.1 379 95.1 381 95.9 381 95.9 379 95.1 379"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "uuid-425e26d6-b358-4618-a922-ed49ef724d85",
    points: "95.1 381 95.1 383.1 95.9 383.1 95.9 381 95.1 381"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76,379c0,2.5,2.1,4.6,4.6,4.6s4.6-2,4.6-4.6-2.1-4.6-4.6-4.6-4.6,2.1-4.6,4.6ZM80.3,374.7c-.3.3-1.1,1.1-1.1,2.2s0,.6.2.9c-.3-.1-.6-.2-.9-.2-1.1,0-1.9.8-2.2,1.1.1-2.1,1.8-3.9,4-4ZM80.6,375c.3.3,1,1,1,1.9s-.2,1-.6,1.4c-.2.1-.3.3-.4.4-.2-.2-.3-.3-.5-.5-.3-.4-.5-.8-.5-1.3,0-.9.7-1.7,1-1.9ZM76.6,379c.3-.3,1-1,1.9-1,.5,0,.9.2,1.3.5.1.2.3.3.5.5,0,0-.2.2-.4.4-.5.4-.9.6-1.4.6-.9,0-1.7-.7-1.9-1ZM80.6,379.2c0,0,.2.2.3.3.3.4.7,1,.7,1.6s-.3,1.2-1,1.8c-.7-.6-1-1.2-1-1.8s.3-1.2.6-1.5c.1-.1.3-.2.4-.4ZM76.3,379.2c.3.3,1.1,1.1,2.2,1.1.3,0,.7,0,1-.2-.2.3-.3.7-.3,1.1,0,.7.4,1.4,1.1,2-2.1-.1-3.8-1.8-4-4ZM80.8,383.2c.7-.6,1.1-1.3,1.1-2s-.1-.8-.3-1.1c.3.2.7.3,1.1.3.7,0,1.4-.4,2.1-1.1-.1,2.1-1.8,3.8-4,4ZM84.6,379c-.6.7-1.2,1-1.8,1-.7,0-1.3-.4-1.6-.7-.1-.1-.2-.2-.3-.3.1-.1.3-.3.4-.4.4-.3.9-.6,1.5-.6.6,0,1.3.3,1.8,1ZM84.8,378.7c-.6-.7-1.3-1.1-2.1-1.1-.4,0-.7.1-1.1.3.1-.3.2-.6.2-1,0-1.1-.8-1.9-1.1-2.2,2.1.1,3.8,1.8,4,4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9,381.2c0-.3-.3-.6-.6-.6s-.6.3-.6.6.3.6.6.6.6-.3.6-.6ZM78,381.2c0-.1.1-.3.3-.3s.3.1.3.3-.1.3-.3.3-.3-.1-.3-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.3,381.2c0,.3.3.6.6.6s.6-.3.6-.6-.3-.6-.6-.6-.6.3-.6.6ZM83.2,381.2c0,.1-.1.3-.3.3s-.3-.1-.3-.3.1-.3.3-.3.3.1.3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.9,376.8c0-.3-.3-.6-.6-.6s-.6.3-.6.6.3.6.6.6c.3,0,.6-.3.6-.6ZM78,376.8c0-.1.1-.3.3-.3s.3.1.3.3-.1.3-.3.3-.3-.1-.3-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.3,376.8c0,.3.3.6.6.6s.6-.3.6-.6-.3-.6-.6-.6c-.3,0-.6.3-.6.6ZM83.2,376.8c0,.1-.1.3-.3.3s-.3-.1-.3-.3.1-.3.3-.3.3.1.3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-61e72ca5-1928-4024-912a-46feb0769b5d",
    d: "M110.3,382.8v-7.6c0-2.3-.8-2-3.2-2h-5.2v11.7h5.2c2.3,0,3.2.3,3.2-2Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "uuid-a21a5fc7-dfaf-4984-83a4-779d70d4a70c",
    points: "101.8 361.3 103.1 367.4 104.5 361.3 101.8 361.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "uuid-61e72ca5-1928-4024-912a-46feb0769b5d",
    points: "102.7 366.1 103.1 367.4 103.6 366.1 102.7 366.1"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "uuid-61e72ca5-1928-4024-912a-46feb0769b5d",
    x: 101.8,
    y: 318.9,
    width: 2.8,
    height: 42.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "uuid-e5c2021b-defc-4aaf-90a6-399609577ef4",
    x: 101.8,
    y: 317.3,
    width: 2.8,
    height: 1.6
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "uuid-0a1bbc5a-b788-4ce2-8500-fb677d294b64",
    points: "104.5 318.3 104.5 318.9 101.8 318.9 101.8 318.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-61e72ca5-1928-4024-912a-46feb0769b5d",
    d: "M104.5,317.3v-1.7c0-.8-.6-1.4-1.4-1.4s-1.4.6-1.4,1.4v1.7h2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-61e72ca5-1928-4024-912a-46feb0769b5d",
    d: "M86.3,352.6h2.9c1.9-17.9,0-36.6,0-36.6h-2.9s-2,20.4,0,36.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-e5c2021b-defc-4aaf-90a6-399609577ef4",
    d: "M90,333.8c0-.5,0-1,0-1.5h-4.6c0,.5,0,1,0,1.5h4.6Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "uuid-e5c2021b-defc-4aaf-90a6-399609577ef4",
    points: "86.3 352.6 89.2 352.6 88 358.5 87.4 358.5 86.3 352.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-488da7f8-93e7-4c83-947b-6ac19dfe1036",
    d: "M87.9,359.3v-.8c.1,0-.4,0-.4,0v.8c.1,0,.1.1.3.1,0,0,.1,0,.1-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-e5c2021b-defc-4aaf-90a6-399609577ef4",
    d: "M89.2,316v-.9c0-.8-.7-1.5-1.5-1.5s-1.5.7-1.5,1.5v.9h2.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-e5c2021b-defc-4aaf-90a6-399609577ef4",
    d: "M89.2,316h.7c.5.1.5.9.5.9v11.2c0,1.2.8,1.5.8,1.5.5,0,.4-.6.4-.6-.5-.4-.5-1.1-.5-1.1v-11.3s0-1.1-.7-1.3h-1.2v.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-61e72ca5-1928-4024-912a-46feb0769b5d",
    d: "M233.7,425.7l-7.1,36.5c-.1.7.4,1.4,1.2,1.4h3.7l2.2-37.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-7c0d99eb-719b-4d41-a9c4-28b0e89f84ad",
    d: "M233.8,425.6l-4.7,35.8c-.2,1.2.8,2.2,2,2.2h6.9l-3.9-38.2h-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-843519b8-8e9f-4a81-9212-d141e78086bf",
    d: "M233.8,425.6l-2.1,35.6c0,1.3,1,2.5,2.3,2.5h10.2l-10.5-38.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-5b12d0c7-67da-4724-9c8f-41693657877a",
    d: "M233.7,425.9l1,35.3c0,1.3,1,2.5,2.3,2.5h10.2l-13.6-37.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-0c9c3356-e5d9-4504-ade4-a7ed86cb66ac",
    d: "M282.7,463.6h-40.4c-1,0-1.9-.7-2.1-1.7l-6.1-33.6c-.3-1.5.9-2.9,2.4-2.9h39.9c1,0,1.9.7,2.1,1.7l6.2,34.1c.2,1.3-.7,2.5-2.1,2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-61e72ca5-1928-4024-912a-46feb0769b5d",
    d: "M235,432.7h44.6l-1.1-6.3c0-.6-.6-1-1.1-1h-43.2c-.2,0-.4.2-.4.4l1.3,6.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-5b12d0c7-67da-4724-9c8f-41693657877a",
    d: "M236,423.5c-1.1,0-1.9.9-1.9,1.9h.4c0-.9.7-1.6,1.6-1.6s1.6.7,1.6,1.6,0,.3,0,.5c-.2.5-.5.8-1,1-.1,0-.3,0-.4,0v.4c.2,0,.3,0,.5,0,.6-.2,1.1-.7,1.3-1.4,0-.2,0-.3,0-.5,0-1.1-.9-1.9-1.9-1.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-5b12d0c7-67da-4724-9c8f-41693657877a",
    d: "M236.6,427.2s0,0,0,.1c0,.2-.2.3-.4.3s-.4-.2-.4-.4.2-.4.4-.4.3,0,.3.2c0,0,0,.2,0,.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-5b12d0c7-67da-4724-9c8f-41693657877a",
    d: "M243,423.5c-1.1,0-1.9.9-1.9,1.9h.4c0-.9.7-1.6,1.6-1.6s1.6.7,1.6,1.6,0,.3,0,.5c-.2.5-.5.8-1,1-.1,0-.3,0-.4,0v.4c.2,0,.3,0,.5,0,.6-.2,1.1-.7,1.3-1.4,0-.2,0-.3,0-.5,0-1.1-.9-1.9-1.9-1.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-5b12d0c7-67da-4724-9c8f-41693657877a",
    d: "M243.6,427.2s0,0,0,.1c0,.2-.2.3-.4.3s-.4-.2-.4-.4.2-.4.4-.4.3,0,.3.2c0,0,0,.2,0,.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-5b12d0c7-67da-4724-9c8f-41693657877a",
    d: "M249.9,423.5c-1.1,0-1.9.9-1.9,1.9h.4c0-.9.7-1.6,1.6-1.6s1.6.7,1.6,1.6,0,.3,0,.5c-.2.5-.5.8-1,1-.1,0-.3,0-.4,0v.4c.2,0,.3,0,.5,0,.6-.2,1.1-.7,1.3-1.4,0-.2,0-.3,0-.5,0-1.1-.9-1.9-1.9-1.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-5b12d0c7-67da-4724-9c8f-41693657877a",
    d: "M250.5,427.2s0,0,0,.1c0,.2-.2.3-.4.3s-.4-.2-.4-.4.2-.4.4-.4.3,0,.3.2c0,0,0,.2,0,.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-5b12d0c7-67da-4724-9c8f-41693657877a",
    d: "M256.8,423.5c-1.1,0-1.9.9-1.9,1.9h.4c0-.9.7-1.6,1.6-1.6s1.6.7,1.6,1.6,0,.3,0,.5c-.2.5-.5.8-1,1-.1,0-.3,0-.4,0v.4c.2,0,.3,0,.5,0,.6-.2,1.1-.7,1.3-1.4,0-.2,0-.3,0-.5,0-1.1-.9-1.9-1.9-1.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-5b12d0c7-67da-4724-9c8f-41693657877a",
    d: "M257.4,427.2s0,0,0,.1c0,.2-.2.3-.4.3s-.4-.2-.4-.4.2-.4.4-.4.3,0,.3.2c0,0,0,.2,0,.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-5b12d0c7-67da-4724-9c8f-41693657877a",
    d: "M263.8,423.5c-1.1,0-1.9.9-1.9,1.9h.4c0-.9.7-1.6,1.6-1.6s1.6.7,1.6,1.6,0,.3,0,.5c-.2.5-.5.8-1,1-.1,0-.3,0-.4,0v.4c.2,0,.3,0,.5,0,.6-.2,1.1-.7,1.3-1.4,0-.2,0-.3,0-.5,0-1.1-.9-1.9-1.9-1.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-5b12d0c7-67da-4724-9c8f-41693657877a",
    d: "M264.4,427.2s0,0,0,.1c0,.2-.2.3-.4.3s-.4-.2-.4-.4.2-.4.4-.4.3,0,.3.2c0,0,0,.2,0,.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-5b12d0c7-67da-4724-9c8f-41693657877a",
    d: "M270.7,423.5c-1.1,0-1.9.9-1.9,1.9h.4c0-.9.7-1.6,1.6-1.6s1.6.7,1.6,1.6,0,.3,0,.5c-.2.5-.5.8-1,1-.1,0-.3,0-.4,0v.4c.2,0,.3,0,.5,0,.6-.2,1.1-.7,1.3-1.4,0-.2,0-.3,0-.5,0-1.1-.9-1.9-1.9-1.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-5b12d0c7-67da-4724-9c8f-41693657877a",
    d: "M271.3,427.2s0,0,0,.1c0,.2-.2.3-.4.3s-.4-.2-.4-.4.2-.4.4-.4.3,0,.3.2c0,0,0,.2,0,.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-5b12d0c7-67da-4724-9c8f-41693657877a",
    d: "M277.6,423.5c-1.1,0-1.9.9-1.9,1.9h.4c0-.9.7-1.6,1.6-1.6s1.6.7,1.6,1.6,0,.3,0,.5c-.2.5-.5.8-1,1-.1,0-.3,0-.4,0v.4c.2,0,.3,0,.5,0,.6-.2,1.1-.7,1.3-1.4,0-.2,0-.3,0-.5,0-1.1-.9-1.9-1.9-1.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-5b12d0c7-67da-4724-9c8f-41693657877a",
    d: "M278.2,427.2s0,0,0,.1c0,.2-.2.3-.4.3s-.4-.2-.4-.4.2-.4.4-.4.3,0,.3.2c0,0,0,.2,0,.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-855bc41b-68c4-4f30-9e65-8a3ab6ef699e",
    d: "M260.8,444.6h-2.3c-.3,0-.5-.2-.6-.5l-.4-2.3c0-.3.1-.5.4-.5h2.3c.3,0,.5.2.6.5l.4,2.3c0,.3-.1.5-.4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-855bc41b-68c4-4f30-9e65-8a3ab6ef699e",
    d: "M266.5,444.6h-2.3c-.3,0-.5-.2-.6-.5l-.4-2.3c0-.3.1-.5.4-.5h2.3c.3,0,.5.2.6.5l.4,2.3c0,.3-.1.5-.4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-7c0d99eb-719b-4d41-a9c4-28b0e89f84ad",
    d: "M272.2,444.6h-2.3c-.3,0-.5-.2-.6-.5l-.4-2.3c0-.3.1-.5.4-.5h2.3c.3,0,.5.2.6.5l.4,2.3c0,.3-.1.5-.4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-855bc41b-68c4-4f30-9e65-8a3ab6ef699e",
    d: "M243.7,444.6h-2.3c-.3,0-.5-.2-.6-.5l-.4-2.3c0-.3.1-.5.4-.5h2.3c.3,0,.5.2.6.5l.4,2.3c0,.3-.1.5-.4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-61e72ca5-1928-4024-912a-46feb0769b5d",
    d: "M241.2,437.8h-1c-.1,0-.2,0-.2-.2l-.2-1c0-.1,0-.2.2-.2h1c.1,0,.2,0,.2.2l.2,1c0,.1,0,.2-.2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-855bc41b-68c4-4f30-9e65-8a3ab6ef699e",
    d: "M249.4,444.6h-2.3c-.3,0-.5-.2-.6-.5l-.4-2.3c0-.3.1-.5.4-.5h2.3c.3,0,.5.2.6.5l.4,2.3c0,.3-.1.5-.4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-855bc41b-68c4-4f30-9e65-8a3ab6ef699e",
    d: "M255.1,444.6h-2.3c-.3,0-.5-.2-.6-.5l-.4-2.3c0-.3.1-.5.4-.5h2.3c.3,0,.5.2.6.5l.4,2.3c0,.3-.1.5-.4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-7c0d99eb-719b-4d41-a9c4-28b0e89f84ad",
    d: "M277.9,444.6h-2.3c-.3,0-.5-.2-.6-.5l-.4-2.3c0-.3.1-.5.4-.5h2.3c.3,0,.5.2.6.5l.4,2.3c0,.3-.1.5-.4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-855bc41b-68c4-4f30-9e65-8a3ab6ef699e",
    d: "M259.8,439.7h-2.3c-.3,0-.5-.2-.6-.5l-.4-2.3c0-.3.1-.5.4-.5h2.3c.3,0,.5.2.6.5l.4,2.3c0,.3-.1.5-.4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-855bc41b-68c4-4f30-9e65-8a3ab6ef699e",
    d: "M265.5,439.7h-2.3c-.3,0-.5-.2-.6-.5l-.4-2.3c0-.3.1-.5.4-.5h2.3c.3,0,.5.2.6.5l.4,2.3c0,.3-.1.5-.4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-7c0d99eb-719b-4d41-a9c4-28b0e89f84ad",
    d: "M271.2,439.7h-2.3c-.3,0-.5-.2-.6-.5l-.4-2.3c0-.3.1-.5.4-.5h2.3c.3,0,.5.2.6.5l.4,2.3c0,.3-.1.5-.4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-7c0d99eb-719b-4d41-a9c4-28b0e89f84ad",
    d: "M276.9,439.7h-2.3c-.3,0-.5-.2-.6-.5l-.4-2.3c0-.3.1-.5.4-.5h2.3c.3,0,.5.2.6.5l.4,2.3c0,.3-.1.5-.4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-855bc41b-68c4-4f30-9e65-8a3ab6ef699e",
    d: "M261.8,449.8h-2.3c-.3,0-.5-.2-.6-.5l-.4-2.3c0-.3.1-.5.4-.5h2.3c.3,0,.5.2.6.5l.4,2.3c0,.3-.1.5-.4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-855bc41b-68c4-4f30-9e65-8a3ab6ef699e",
    d: "M267.5,449.8h-2.3c-.3,0-.5-.2-.6-.5l-.4-2.3c0-.3.1-.5.4-.5h2.3c.3,0,.5.2.6.5l.4,2.3c0,.3-.1.5-.4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-7c0d99eb-719b-4d41-a9c4-28b0e89f84ad",
    d: "M273.2,449.8h-2.3c-.3,0-.5-.2-.6-.5l-.4-2.3c0-.3.1-.5.4-.5h2.3c.3,0,.5.2.6.5l.4,2.3c0,.3-.1.5-.4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-855bc41b-68c4-4f30-9e65-8a3ab6ef699e",
    d: "M244.7,449.8h-2.3c-.3,0-.5-.2-.6-.5l-.4-2.3c0-.3.1-.5.4-.5h2.3c.3,0,.5.2.6.5l.4,2.3c0,.3-.1.5-.4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-855bc41b-68c4-4f30-9e65-8a3ab6ef699e",
    d: "M250.4,449.8h-2.3c-.3,0-.5-.2-.6-.5l-.4-2.3c0-.3.1-.5.4-.5h2.3c.3,0,.5.2.6.5l.4,2.3c0,.3-.1.5-.4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-855bc41b-68c4-4f30-9e65-8a3ab6ef699e",
    d: "M256.1,449.8h-2.3c-.3,0-.5-.2-.6-.5l-.4-2.3c0-.3.1-.5.4-.5h2.3c.3,0,.5.2.6.5l.4,2.3c0,.3-.1.5-.4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-7c0d99eb-719b-4d41-a9c4-28b0e89f84ad",
    d: "M278.9,449.8h-2.3c-.3,0-.5-.2-.6-.5l-.4-2.3c0-.3.1-.5.4-.5h2.3c.3,0,.5.2.6.5l.4,2.3c0,.3-.1.5-.4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-855bc41b-68c4-4f30-9e65-8a3ab6ef699e",
    d: "M262.8,455h-2.3c-.3,0-.5-.2-.6-.5l-.4-2.3c0-.3.1-.5.4-.5h2.3c.3,0,.5.2.6.5l.4,2.3c0,.3-.1.5-.4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-855bc41b-68c4-4f30-9e65-8a3ab6ef699e",
    d: "M268.5,455h-2.3c-.3,0-.5-.2-.6-.5l-.4-2.3c0-.3.1-.5.4-.5h2.3c.3,0,.5.2.6.5l.4,2.3c0,.3-.1.5-.4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-7c0d99eb-719b-4d41-a9c4-28b0e89f84ad",
    d: "M274.2,455h-2.3c-.3,0-.5-.2-.6-.5l-.4-2.3c0-.3.1-.5.4-.5h2.3c.3,0,.5.2.6.5l.4,2.3c0,.3-.1.5-.4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-855bc41b-68c4-4f30-9e65-8a3ab6ef699e",
    d: "M245.7,455h-2.3c-.3,0-.5-.2-.6-.5l-.4-2.3c0-.3.1-.5.4-.5h2.3c.3,0,.5.2.6.5l.4,2.3c0,.3-.1.5-.4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-61e72ca5-1928-4024-912a-46feb0769b5d",
    d: "M251.4,455h-2.3c-.3,0-.5-.2-.6-.5l-.4-2.3c0-.3.1-.5.4-.5h2.3c.3,0,.5.2.6.5l.4,2.3c0,.3-.1.5-.4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-855bc41b-68c4-4f30-9e65-8a3ab6ef699e",
    d: "M257.1,455h-2.3c-.3,0-.5-.2-.6-.5l-.4-2.3c0-.3.1-.5.4-.5h2.3c.3,0,.5.2.6.5l.4,2.3c0,.3-.1.5-.4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-7c0d99eb-719b-4d41-a9c4-28b0e89f84ad",
    d: "M279.9,455h-2.3c-.3,0-.5-.2-.6-.5l-.4-2.3c0-.3.1-.5.4-.5h2.3c.3,0,.5.2.6.5l.4,2.3c0,.3-.1.5-.4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-855bc41b-68c4-4f30-9e65-8a3ab6ef699e",
    d: "M263.7,459.9h-2.3c-.3,0-.5-.2-.6-.5l-.4-2.3c0-.3.1-.5.4-.5h2.3c.3,0,.5.2.6.5l.4,2.3c0,.3-.1.5-.4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-855bc41b-68c4-4f30-9e65-8a3ab6ef699e",
    d: "M269.4,459.9h-2.3c-.3,0-.5-.2-.6-.5l-.4-2.3c0-.3.1-.5.4-.5h2.3c.3,0,.5.2.6.5l.4,2.3c0,.3-.1.5-.4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-7c0d99eb-719b-4d41-a9c4-28b0e89f84ad",
    d: "M275.1,459.9h-2.3c-.3,0-.5-.2-.6-.5l-.4-2.3c0-.3.1-.5.4-.5h2.3c.3,0,.5.2.6.5l.4,2.3c0,.3-.1.5-.4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-855bc41b-68c4-4f30-9e65-8a3ab6ef699e",
    d: "M246.6,459.9h-2.3c-.3,0-.5-.2-.6-.5l-.4-2.3c0-.3.1-.5.4-.5h2.3c.3,0,.5.2.6.5l.4,2.3c0,.3-.1.5-.4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-855bc41b-68c4-4f30-9e65-8a3ab6ef699e",
    d: "M252.3,459.9h-2.3c-.3,0-.5-.2-.6-.5l-.4-2.3c0-.3.1-.5.4-.5h2.3c.3,0,.5.2.6.5l.4,2.3c0,.3-.1.5-.4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-855bc41b-68c4-4f30-9e65-8a3ab6ef699e",
    d: "M258,459.9h-2.3c-.3,0-.5-.2-.6-.5l-.4-2.3c0-.3.1-.5.4-.5h2.3c.3,0,.5.2.6.5l.4,2.3c0,.3-.1.5-.4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-855bc41b-68c4-4f30-9e65-8a3ab6ef699e",
    d: "M248.1,437h-6c0,0-.2,0-.2-.2h0c0,0,0-.2.2-.2h6c0,0,.2,0,.2.2h0c0,0,0,.2-.2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-855bc41b-68c4-4f30-9e65-8a3ab6ef699e",
    d: "M248.2,437.7h-6c0,0-.2,0-.2-.2h0c0,0,0-.2.2-.2h6c0,0,.2,0,.2.2h0c0,0,0,.2-.2.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-0a1bbc5a-b788-4ce2-8500-fb677d294b64",
    d: "M241.7,431.6h-2.1c-.2,0-.3-.1-.3-.3h0c0-.2.1-.3.3-.3h2.1c.2,0,.3.1.3.3h0c0,.2-.1.3-.3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-0a1bbc5a-b788-4ce2-8500-fb677d294b64",
    d: "M247.3,431.6h-2.1c-.2,0-.3-.1-.3-.3h0c0-.2.1-.3.3-.3h2.1c.2,0,.3.1.3.3h0c0,.2-.1.3-.3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-0a1bbc5a-b788-4ce2-8500-fb677d294b64",
    d: "M252.9,431.6h-2.1c-.2,0-.3-.1-.3-.3h0c0-.2.1-.3.3-.3h2.1c.2,0,.3.1.3.3h0c0,.2-.1.3-.3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-0a1bbc5a-b788-4ce2-8500-fb677d294b64",
    d: "M258.5,431.6h-2.1c-.2,0-.3-.1-.3-.3h0c0-.2.1-.3.3-.3h2.1c.2,0,.3.1.3.3h0c0,.2-.1.3-.3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-0a1bbc5a-b788-4ce2-8500-fb677d294b64",
    d: "M264.2,431.6h-2.1c-.2,0-.3-.1-.3-.3h0c0-.2.1-.3.3-.3h2.1c.2,0,.3.1.3.3h0c0,.2-.1.3-.3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-0a1bbc5a-b788-4ce2-8500-fb677d294b64",
    d: "M269.8,431.6h-2.1c-.2,0-.3-.1-.3-.3h0c0-.2.1-.3.3-.3h2.1c.2,0,.3.1.3.3h0c0,.2-.1.3-.3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-0a1bbc5a-b788-4ce2-8500-fb677d294b64",
    d: "M275.4,431.6h-2.1c-.2,0-.3-.1-.3-.3h0c0-.2.1-.3.3-.3h2.1c.2,0,.3.1.3.3h0c0,.2-.1.3-.3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-2bd656d8-662a-4244-91e9-27755fde6f06",
    d: "M262.5,439.8c-.5,0-.8-.1-1-.4-.3-.5,0-1.3.8-2.2.6-.7,1.4-1.2,1.4-1.2,0,0,0,0,0,0,0,0,0,0,0,0,0,0-2.9,2.1-2.1,3.3.2.4.7.4,1.1.3.7,0,1.6-.5,2.5-1,.9-.6,1.5-1.2,1.7-1.8.1-.4,0-.6-.1-.8-.3-.2-.8-.2-1.5,0-.6.2-1.3.5-1.7.8,0,0,0,0,0,0,0,0,0,0,0,0,.4-.4,1.1-.7,1.7-.9.7-.2,1.3-.2,1.6,0,.2.1.4.4.2.9-.2.6-.8,1.3-1.7,1.8-.9.6-1.8,1-2.5,1-.1,0-.2,0-.3,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-61e72ca5-1928-4024-912a-46feb0769b5d",
    d: "M165.5,459.1c0,.8-.6,1.4-1.4,1.4h-48.4c-.8,0-1.4-.6-1.4-1.4v-32.8c0-.8.6-1.4,1.4-1.4h48.4c.8,0,1.4.6,1.4,1.4v32.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-e5c2021b-defc-4aaf-90a6-399609577ef4",
    d: "M165.5,443.8c0,.8-.6,1.4-1.4,1.4h-48.4c-.8,0-1.4-.6-1.4-1.4v-20.9c0-.8.6-1.4,1.4-1.4h48.4c.8,0,1.4.6,1.4,1.4v20.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-61e72ca5-1928-4024-912a-46feb0769b5d",
    d: "M114.3,424.4v18c0,.8.6,1.4,1.4,1.4h48.4c.8,0,1.4-.6,1.4-1.4v-18h-51.3Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "uuid-e5c2021b-defc-4aaf-90a6-399609577ef4",
    x: 114.3,
    y: 420.2,
    width: 51.3,
    height: 4.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "uuid-21e078d3-d5d9-462e-9988-8c5b2ff32579",
    x: 121,
    y: 451.2,
    width: 6.8,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "uuid-e5c2021b-defc-4aaf-90a6-399609577ef4",
    x: 122.6,
    y: 442.4,
    width: 3.7,
    height: 13.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "uuid-21e078d3-d5d9-462e-9988-8c5b2ff32579",
    x: 122.2,
    y: 446.3,
    width: 4.3,
    height: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-21e078d3-d5d9-462e-9988-8c5b2ff32579",
    d: "M121,447.5v3.7h1.2v-5c-.7,0-1.2.6-1.2,1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-21e078d3-d5d9-462e-9988-8c5b2ff32579",
    d: "M127.8,447.5c0-.7-.6-1.2-1.2-1.2v5h1.2v-3.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-21e078d3-d5d9-462e-9988-8c5b2ff32579",
    d: "M125,448.8c0,.4-.3.7-.7.7h0c-.4,0-.7-.3-.7-.7v-3.4c0-.4.3-.7.7-.7h0c.4,0,.7.3.7.7v3.4Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "uuid-21e078d3-d5d9-462e-9988-8c5b2ff32579",
    x: 152,
    y: 451.2,
    width: 6.8,
    height: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "uuid-e5c2021b-defc-4aaf-90a6-399609577ef4",
    x: 153.5,
    y: 442.4,
    width: 3.7,
    height: 13.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "uuid-21e078d3-d5d9-462e-9988-8c5b2ff32579",
    x: 153.2,
    y: 446.3,
    width: 4.3,
    height: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-21e078d3-d5d9-462e-9988-8c5b2ff32579",
    d: "M158.8,447.5v3.7h-1.2v-5c.7,0,1.2.6,1.2,1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-21e078d3-d5d9-462e-9988-8c5b2ff32579",
    d: "M152,447.5c0-.7.6-1.2,1.2-1.2v5h-1.2v-3.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-21e078d3-d5d9-462e-9988-8c5b2ff32579",
    d: "M154.8,448.8c0,.4.3.7.7.7h0c.4,0,.7-.3.7-.7v-3.4c0-.4-.3-.7-.7-.7h0c-.4,0-.7.3-.7.7v3.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-e5c2021b-defc-4aaf-90a6-399609577ef4",
    d: "M139.4,444.6s.6,15.9-2.2,15.9h2.7v-15.9h-.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-e5c2021b-defc-4aaf-90a6-399609577ef4",
    d: "M140.5,444.6s-.6,15.9,2.2,15.9h-2.7v-15.9h.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-e5c2021b-defc-4aaf-90a6-399609577ef4",
    d: "M115.1,444.4l-.8-.5h0v15.2c0,.8.6,1.4,1.4,1.4h2.1c-2.7,0-2.7-16.1-2.7-16.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-e5c2021b-defc-4aaf-90a6-399609577ef4",
    d: "M164.7,444.4l.8-.5h0v15.2c0,.8-.6,1.4-1.4,1.4h-2.1c2.7,0,2.7-16.1,2.7-16.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-21e078d3-d5d9-462e-9988-8c5b2ff32579",
    d: "M130.1,418.8v3.2s.2.3,1.2.3,1.5-.3,1.5-.3v-3.2c0-.7.4-1.4,1-1.8v-2.9c-2.1.5-3.7,2.4-3.7,4.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "uuid-931483f3-9c4d-4d81-99bc-c1c8ecdf2fb9",
    d: "M146.3,414.1v2.9c.5.4.9,1,.9,1.8v3.2s.2.3,1.5.3,1.2-.3,1.2-.3v-3.2c0-2.2-1.6-4.1-3.6-4.7Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "uuid-dac06365-2717-4c05-b8be-afcf2a63f34d",
    x: 133.5,
    y: 413.8,
    width: 13,
    height: 3.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "uuid-e5c2021b-defc-4aaf-90a6-399609577ef4",
    x: 115.7,
    y: 459.6,
    width: 48.6,
    height: 0.9
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "uuid-931483f3-9c4d-4d81-99bc-c1c8ecdf2fb9",
    points: "133.5 415.9 145.3 415.7 145.3 414.3 133.5 414.2 133.5 415.9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.8d0fee1f7be0c51a26ca7d63850c4a76.svg";
export { ForwardRef as ReactComponent };